"use strict";

// Helpers
//
const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};

// Main Menu
//
if (isTouchDevice()) {
  const subMenuNavs = document.querySelectorAll(".has-sub-menu > a");
  subMenuNavs.forEach((mainMenuNav) => {
    mainMenuNav.addEventListener("click", (event) => {
      if (!isTouchDevice()) {
        return;
      }

      subMenuNavs.forEach((item) => {
        if (item === mainMenuNav) {
          return;
        }

        item.classList.remove("is-dropdown-open");
      });

      if (mainMenuNav.classList.contains("is-dropdown-open")) {
        return;
      }

      event.preventDefault();
      mainMenuNav.classList.add("is-dropdown-open");
    });
  });
}

class DropdownModal extends HTMLElement {
  constructor() {
    super();

    this.eventPrefix = this.dataset.eventPrefix;
    this.toggles = this.querySelectorAll(".dropdown-modal-toggle");
    this.content = this.querySelector(".dropdown-modal-toggle + div");
    this.preventOpen = this.getAttribute("prevent-open") === "true";

    if (this.preventOpen) {
      return;
    }

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.close();
      }
    });
    this.toggles.forEach((toggle) => {
      toggle.addEventListener("click", this.handleToggle.bind(this));
    });
  }

  isOpen() {
    return this.getAttribute("open") === "true";
  }

  handleToggle(event) {
    event?.preventDefault?.();

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  open(opener) {
    this.openedBy = opener;
    this.setAttribute("open", true);
    this.toggles.forEach((toggle) => {
      toggle.setAttribute("aria-expanded", true);
    });
    trapFocus(this);

    if (this.eventPrefix) {
      publish(`${this.eventPrefix}:open`);
    }

    document.querySelectorAll("localization-form")?.forEach?.((localizationForm) => {
      localizationForm?.hidePanel?.();
    });
  }

  close() {
    this.toggles.forEach((toggle) => {
      toggle.setAttribute("aria-expanded", false);
    });
    this.removeAttribute("open");

    if (this.openedBy) {
      removeTrapFocus(this.openedBy);
    }

    if (this.eventPrefix) {
      publish(`${this.eventPrefix}:close`);
    }
  }
}

customElements.define("dropdown-modal", DropdownModal);

class HeaderSearchDropdownModal extends DropdownModal {
  constructor() {
    super();
    this.searchInput = this.querySelector('input[type="search"]');
  }

  open(opener) {
    super.open(opener);
    trapFocus(this, this.searchInput);
  }
}

customElements.define("header-search-dropdown-modal", HeaderSearchDropdownModal);

// Menu classes based on available free space
//
const navigations = document.querySelectorAll(".navigation-menu");

navigations.forEach((navigation) => {
  const navigationMenusTopNavs = navigation.querySelectorAll(":scope > .has-sub-menu");

  const getMenuWidth = (element, initialWidth = 0) => {
    const submenu = element && element.querySelector(".navigation-sub-menu");

    if (!submenu) {
      return initialWidth;
    }

    return getMenuWidth(submenu, initialWidth + submenu.clientWidth);
  };

  const setMenuClasses = () => {
    const windowWidth = window.innerWidth;
    navigationMenusTopNavs.forEach((navigationMenusTopNav) => {
      if (navigationMenusTopNav.classList.contains("navigation-item-static")) {
        return;
      }

      navigationMenusTopNav.classList.remove("nav-open-left");
      const width = getMenuWidth(navigationMenusTopNav);

      if (navigationMenusTopNav.offsetLeft + width > windowWidth) {
        navigationMenusTopNav.classList.add("nav-open-left");
      }
    });
  };

  setMenuClasses();

  let resizeTimer;

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setMenuClasses();
    }, 350);
  });
});

// Sidebar drawer button toggle
//
const sidebarDrawerButton = document.querySelector(".button-sidebar-drawer-open");
const sidebarDrawer = document.querySelector(".page-layout-sidebar");

const handleSidebarOpen = () => {
  document.body.classList.add("page-layout-sidebar-drawer-open");
  document.body.classList.add("overflow-hidden-tablet");
  trapFocus(sidebarDrawer, sidebarDrawer.querySelector(".page-layout-sidebar-drawer-header"));
};

const handleSidebarDismiss = () => {
  document.body.classList.remove("page-layout-sidebar-drawer-open");
  document.body.classList.remove("overflow-hidden-tablet");
  removeTrapFocus(sidebarDrawerButton);
};

const isSidebarOpen = () => {
  return document.body.classList.contains("page-layout-sidebar-drawer-open");
};

if (sidebarDrawerButton && sidebarDrawer) {
  document.body.addEventListener("click", (event) => {
    const { target } = event;

    if (target.classList.contains("js-button-sidebar-drawer-dismiss")) {
      handleSidebarDismiss();
      return;
    }

    if (target.classList.contains("button-sidebar-drawer-open")) {
      handleSidebarOpen();
      return;
    }

    if (isSidebarOpen() && !target.closest(".page-layout-sidebar")) {
      handleSidebarDismiss();
      event.preventDefault();
    }
  });

  sidebarDrawer.addEventListener("keyup", (event) => {
    if (event.code.toUpperCase() === "ESCAPE") {
      handleSidebarDismiss();
    }
  });
}

document.addEventListener("change", (event) => {
  if (event.target.parentNode?.classList.contains("select-custom")) {
    const select = event.target;
    const label = select.parentNode.querySelector("label");
    label.textContent = select.options[select.selectedIndex].text;
  }
});

// Review links / scroll
//
(() => {
  // Shopify app review link
  const reviewsLink = document.querySelectorAll('a[href*="#product-reviews"]');
  const reviews = document.getElementById("product-reviews");

  if (reviewsLink && reviews) {
    reviewsLink.forEach((link) => {
      link.addEventListener("click", () => {
        reviews.expand();
      });
    });
  }

  if (window.location.hash === "#product-reviews" && reviews) {
    setTimeout(() => {
      reviews.expand();
    }, 0);

    setTimeout(() => {
      reviews.scrollIntoView();
    }, 200);
  }
})();

(() => {
  // App review links
  const appReviewLinks = document.querySelectorAll(".star-rating-badge");
  const reviews = document.getElementById("product-reviews");

  if (appReviewLinks.length > 0 && reviews) {
    appReviewLinks.forEach((link) => {
      if (link.classList.contains("star-rating-link")) {
        return;
      }

      link.addEventListener("click", () => {
        reviews.expand();
      });
    });
  }

  if (appReviewLinks.length > 0 && !reviews) {
    appReviewLinks.forEach((link) => {
      if (link.classList.contains("star-rating-link")) {
        return;
      }

      const parentCard = link.closest(".card-product");

      if (parentCard) {
        const href = parentCard.querySelector(".card-heading > a")?.getAttribute("href");
        link.addEventListener("click", () => {
          window.location = `${href}#product-reviews`;
        });
      }
    });
  }
})();

// Collapsible / Expandable
//
class CollapsibleExpandable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.collapsed = this.getAttribute("expanded") === "false";
    this.toggleElement = this.querySelector(".facet-toggle");

    this.onToggle = this.onToggle.bind(this);
    this.toggleElement.addEventListener("click", this.onToggle);

    // Expandable list
    this.list = this.querySelector(".facet-options-list");
    this.listCollapsed = this.list && this.list.getAttribute("aria-expanded") === "false";
    this.expandListToggle = this.querySelector(".facet-button-more");

    this.onListToggle = this.onListToggle.bind(this);

    if (this.expandListToggle) {
      this.expandListToggle.addEventListener("click", this.onListToggle);
    }

    this.shouldCollapseOthers = this.dataset.collapseOthers === "true";
  }

  disconnectedCallback() {
    this.toggleElement.removeEventListener("click", this.onToggle);

    if (this.expandListToggle) {
      this.expandListToggle.removeEventListener("click", this.onListToggle());
    }
  }

  onToggle(event) {
    event.preventDefault();
    this.handleToggle();
  }

  collapse() {
    this.setAttribute("expanded", "false");
    this.toggleElement.setAttribute("aria-expanded", "false");
    this.collapsed = true;
  }

  expand() {
    this.setAttribute("expanded", "true");
    this.toggleElement.setAttribute("aria-expanded", "true");
    this.collapsed = false;
  }

  collapseOthers() {
    for (const child of this.parentElement.children) {
      if (child === this) {
        continue;
      }
      if (child.tagName === "COLLAPSIBLE-EXPANDABLE") {
        child.collapse();
      }
    }

    const rect = this.getBoundingClientRect();
    const stickyHeader = document.querySelector(".section-header-sticky");
    const headerOffset = stickyHeader ? stickyHeader.offsetHeight : 0;
    const isInView = rect.top >= headerOffset && rect.top <= window.innerHeight;

    if (!isInView) {
      const scrollTop = window.scrollY + rect.top - headerOffset;
      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
    }
  }

  handleToggle() {
    if (this.collapsed) {
      this.expand();
      this.shouldCollapseOthers && this.collapseOthers();
    } else {
      this.collapse();
    }
  }

  onListToggle(event) {
    if (event) {
      event.preventDefault();
    }
    this.handleToggleList();
  }

  collapseList() {
    this.list && this.list.setAttribute("aria-expanded", "false");
    if (this.expandListToggle) {
      this.expandListToggle.innerHTML = "&plus; " + window.productsStrings.facetsShowMore;
    }
    this.listCollapsed = true;
  }

  expandList() {
    this.list && this.list.setAttribute("aria-expanded", "true");
    if (this.expandListToggle) {
      this.expandListToggle.innerHTML = "&minus; " + window.productsStrings.facetsShowLess;
    }
    this.listCollapsed = false;
  }

  handleToggleList() {
    if (this.listCollapsed) {
      this.expandList();
    } else {
      this.collapseList();
    }
  }
}

customElements.define("collapsible-expandable", CollapsibleExpandable);

// Generic Modal Dialog
//
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener("click", this.hide.bind(this));

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        ) {
          this.hide();
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") {
          this.hide();
        }
      });
    }
  }

  connectedCallback() {
    if (this.moved || Shopify.designMode) {
      return;
    }

    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    if (this.openedBy) {
      removeTrapFocus(this.openedBy);
    }
    window.pauseAllMedia();
  }
}

customElements.define("modal-dialog", ModalDialog);

// Global modal opener
//
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) {
      return;
    }

    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) {
        modal.show(button);
      }
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class HTMLUpdateUtility {
  #preProcessCallbacks = [];
  #postProcessCallbacks = [];

  constructor() {}

  addPreProcessCallback(callback) {
    this.#preProcessCallbacks.push(callback);
  }

  addPostProcessCallback(callback) {
    this.#postProcessCallbacks.push(callback);
  }

  viewTransition(oldNode, newContent) {
    this.#preProcessCallbacks.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute("form", `${element.form.getAttribute("id")}-${uniqueKey}`);
    });

    this.#postProcessCallbacks.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

// Variations
//
class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.initializeProductSwapUtility();

    this.addEventListener("change", this.handleProductUpdate);

    this.sectionId = this.dataset.section;
    this.hideOutOfStock = this.dataset.variantsVisibility === "hide";
    this.hideSingle = this.dataset.hideSingle === "true";
    this.optionsWithValues = JSON.parse(
      this.querySelector('[type="application/json"][data-id="product-options-with-values"]')
        .textContent,
    );
    this.variants = JSON.parse(
      this.querySelector('[type="application/json"][data-id="product-variants"]')?.textContent ??
        null,
    );

    this.updateVisibility();
  }

  initializeProductSwapUtility() {
    this.swapProductUtility = new HTMLUpdateUtility();
    this.swapProductUtility.addPostProcessCallback((newNode) => {
      window?.Shopify?.PaymentButton?.init();
      window?.ProductModel?.loadShopifyXR();
      publish(PUB_SUB_EVENTS.sectionRefreshed, {
        data: {
          sectionId: this.sectionId,
          resource: {
            type: "product",
            id: newNode.querySelector("variant-selects, variant-radios").dataset.productId,
          },
        },
      });
    });
  }

  /**
   * Synchronously update the visible label of the custom dropdown so the user
   * sees their selection reflected the moment they click — before any network
   * request completes. This is the single biggest perceived-perf win.
   */
  updateDropdownDisplayImmediately(input) {
    if (!input) return;
    const selectEl = input.tagName === "SELECT" ? input : input.closest("select");
    if (!selectEl) return;
    const wrapper = selectEl.closest(".product-form-input-dropdown");
    const display = wrapper?.querySelector(".variant-card__display .variant-card__value");
    if (display) {
      const selectedOption = selectEl.selectedOptions?.[0];
      display.innerText = selectedOption ? selectedOption.text.trim() : selectEl.value;
    }
  }

  handleProductUpdate(event) {
    const input = this.getInputForEventTarget(event.target);
    const targetId = input.id;
    const targetUrl = input.dataset.productUrl || this.dataset.url;
    const sectionId = this.sectionId;

    // FIX: lock scroll position for the duration of the variant swap.
    // Mobile browsers auto-scroll a focused <select> back into view when its
    // native picker closes, and outerHTML replacement can shift focus — both
    // cause a visible jump. We counteract this by instantly forcing the
    // scroll position back on every scroll event during the update window,
    // so any jump is corrected within the same frame (invisible to the user).
    const scrollPosition = window.scrollY;
    const htmlEl = document.documentElement;
    const previousScrollBehavior = htmlEl.style.scrollBehavior;
    htmlEl.style.scrollBehavior = "auto";

    let scrollLockActive = true;
    const scrollLockHandler = () => {
      if (!scrollLockActive) return;
      if (window.scrollY !== scrollPosition) {
        window.scrollTo(0, scrollPosition);
      }
    };
    window.addEventListener("scroll", scrollLockHandler, { passive: true });

    const releaseScrollLock = () => {
      if (!scrollLockActive) return;
      scrollLockActive = false;
      window.removeEventListener("scroll", scrollLockHandler);
      htmlEl.style.scrollBehavior = previousScrollBehavior;
    };

    // Blur the active element so mobile browsers don't try to scroll it back
    // into view once the native option picker closes.
    if (document.activeElement && typeof document.activeElement.blur === "function") {
      document.activeElement.blur();
    }

    // INSTANT UI FEEDBACK — update the visible label right now.
    this.updateDropdownDisplayImmediately(input);

    this.currentVariant = this.getVariantData(targetId);
    this.currentVariant = this.maybeGetFirstAvailableVariant(this.currentVariant, input);

    this.hideVariants = this.dataset.hideVariants === "true";

    let productUrl = this.getProductInfoUrl(targetUrl, this.currentVariant?.id);

    const quickViewDrawer = this.closest("quick-view-drawer");
    if (quickViewDrawer) {
      releaseScrollLock();
      this.handleQuickviewUpdate(productUrl, targetId);
      return;
    }

    this.toggleAddButton(true, "");

    let callback = () => {};

    if (this.dataset.url !== targetUrl || (this.hideVariants && this.currentVariant)) {
      this.updateURL(targetUrl);
      this.updateShareUrl(targetUrl);
      callback = this.handleSwapProduct(sectionId);

      const shouldFetchFullPage = this.dataset.updateUrl === "true";
      productUrl = this.getProductInfoUrl(targetUrl, this.currentVariant?.id, shouldFetchFullPage);
    } else if (!this.currentVariant) {
      this.setUnavailable();
      callback = (html) => {
        this.updatePickupAvailability();
        this.updateOptionValues(html);
      };
    } else {
      this.updateMedia();
      this.updateURL(targetUrl);
      this.updateShareUrl(targetUrl);
      this.updateVariantInput();
      callback = this.handleUpdateProductInfo(sectionId).bind(this);
    }

    // FIX: wrap callback to snap scroll position back instantly right after
    // the main DOM swap, on top of the continuous scroll-lock above.
    const wrappedCallback = (html) => {
      callback(html);
      window.scrollTo(0, scrollPosition);
    };

    this.renderProductInfo(productUrl, targetId, wrappedCallback);

    // Release the lock after the main update AND async side-effect APIs
    // (inventory, delivery message, etc.) have had time to settle.
    setTimeout(releaseScrollLock, 700);
  }

  maybeGetFirstAvailableVariant(currentVariant, inputClicked) {
    let newVariant = currentVariant;

    if (this.variants && this.hideOutOfStock && (!currentVariant || !currentVariant.available)) {
      const selectedOptionPosition =
        inputClicked.closest("fieldset, select").dataset.optionPosition;

      const selectedOptions = Array.from(
        this.querySelectorAll("fieldset input:checked, select option:checked"),
      ).reduce((acc, element) => {
        acc.push(element.value);
        return acc;
      }, []);
      const firstAvailableVariant = this.variants.find((variant) => {
        const variantSlice = variant.options.slice(0, selectedOptionPosition).toString(),
          selectedSlice = selectedOptions.slice(0, selectedOptionPosition).toString();

        return variant.available && variantSlice === selectedSlice;
      });

      if (firstAvailableVariant) {
        newVariant = firstAvailableVariant;
      }
    }

    return newVariant;
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  getWrappingSection(sectionId) {
    return this.closest(`#shopify-section-${sectionId}`) || null;
  }

  handleSwapProduct(sectionId) {
    return (html) => {
      const oldContent = this.getWrappingSection(sectionId);
      if (!oldContent) {
        return;
      }

      document.getElementById(`ProductModal-${sectionId}`)?.remove();

      const response = html.getElementById(`shopify-section-${sectionId}`);

      if (this.dataset.updateUrl === "true") {
        this.swapProductUtility.viewTransition(
          document.querySelector("main"),
          html.querySelector("main"),
        );
        document.querySelector("head title").innerHTML = html.querySelector("head title").innerHTML;
      } else {
        this.swapProductUtility.viewTransition(oldContent, response);
      }
    };
  }

  handleQuickviewUpdate(productUrl, targetId) {
    const quickViewDrawer = this.closest("quick-view-drawer");
    const productForm = quickViewDrawer.querySelector("product-form form");

    if (productForm) {
      productForm.style.opacity = "0.7";
    }

    this.renderProductInfo(productUrl, targetId, (html) => {
      quickViewDrawer.renderProduct(html, this.currentVariant);
    });
  }

  updateMedia() {
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);

    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }

    if (mediaGallery?.setActiveMedia) {
      mediaGallery.setActiveMedia(
        this.currentVariant.featured_media.id,
        mediaGallery.getAttribute("hide-variants") === "true",
      );
    }
  }

  updateURL(url) {
    if (!this.currentVariant || this.dataset.updateUrl === "false") {
      return;
    }
    window.history.replaceState(
      {},
      "",
      `${url}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ""}`,
    );
  }

  updateShareUrl(url) {
    const shareButtons = document.querySelectorAll(
      `Product-${this.dataset.section} .list-social-item a`,
    );
    if (!shareButtons) {
      return;
    }
    shareButtons.forEach((button) => {
      const fullUrl = `${window.shopUrl}${url}${
        this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ""
      }`;
      button.href = `${button.dataset.shareUrl}${encodeURIComponent(fullUrl)}`;
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`,
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");

    if (!pickUpAvailability || !pickUpAvailability.fetchAvailability) {
      return;
    }

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateVisibility() {
    const parent = this.closest(".product-variants");
    const optionControls = Array.from(
      this.querySelectorAll("fieldset[data-option-position], select[data-option-position]") ?? [],
    );

    const hasSingleVariant =
      optionControls.length > 0 &&
      optionControls.every((optionControl) => {
        if (optionControl.tagName === "SELECT") {
          // For dropdowns: count only visible (not hidden/disabled) options
          const visibleOptions = Array.from(
            optionControl.querySelectorAll("option")
          ).filter((o) => !o.hidden && !o.disabled);
          return visibleOptions.length === 1;
        }
        return optionControl.querySelectorAll("input, option").length === 1;
      });

    const hasSingleVariantAvailable =
      optionControls.length > 0 &&
      optionControls.every((optionControl) => {
        if (optionControl.tagName === "SELECT") {
          // For dropdowns: count only visible available options
          const visibleAvailable = Array.from(
            optionControl.querySelectorAll('[data-variant-available="true"]')
          ).filter((o) => !o.hidden && !o.disabled);
          return visibleAvailable.length === 1;
        }
        return optionControl.querySelectorAll('[data-variant-available="true"]').length === 1;
      });

    if (
      this.hideSingle &&
      (hasSingleVariant || (this.hideOutOfStock && hasSingleVariantAvailable))
    ) {
      parent?.classList.add("hidden");
    } else {
      parent?.classList.remove("hidden");
      parent?.classList.add("variants-visible");
      parent?.classList.remove("variants-hidden");
    }
  }

  updateOptionValues(html) {
    const variantSelects = html.querySelector("variant-selects, variant-radios");
    if (!variantSelects) return;

    const currentOptions = this.querySelectorAll("[data-option-position]");

    currentOptions.forEach((currentOption) => {
      const position = currentOption.dataset.optionPosition;
      const newOption = variantSelects.querySelector(`[data-option-position="${position}"]`);
      if (!newOption) return;

      if (currentOption.tagName === "SELECT" && newOption.tagName === "SELECT") {
        const previousValue = currentOption.value;
        currentOption.innerHTML = newOption.innerHTML;

        // Re-apply disabled+hidden to unavailable options after server re-render
        Array.from(currentOption.querySelectorAll("option")).forEach((opt) => {
          if (opt.dataset.variantAvailable === "false") {
            opt.disabled = true;
            opt.hidden = true;
          }
        });

        // Try to restore previous value if still visible and available
        const previousOption = Array.from(currentOption.options).find(
          (o) => o.value === previousValue && !o.hidden && !o.disabled
        );

        if (previousOption) {
          // Previous value still available — restore it
          currentOption.value = previousValue;
        } else {
          // Previous value unavailable — select first visible available option
          const firstAvailable = Array.from(currentOption.options).find(
            (o) => !o.hidden && !o.disabled
          );
          if (firstAvailable) {
            currentOption.value = firstAvailable.value;
            // Trigger change so variant JS updates price/SKU/etc
            currentOption.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }

        // Sync the visible display label with the actual selected option
        const wrapper = currentOption.closest(".product-form-input-dropdown");
        const display = wrapper?.querySelector(".variant-card__display .variant-card__value");
        if (display) {
          const selected = currentOption.selectedOptions?.[0];
          if (selected) display.innerText = selected.text.trim();
        }

      } else if (currentOption.tagName === "FIELDSET" && newOption.tagName === "FIELDSET") {
        const currentInner = currentOption.querySelector("div");
        const newInner = newOption.querySelector("div");
        if (currentInner && newInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }
      }
    });

    // Re-run visibility check after options are updated
    this.updateVisibility();
  }

  getProductInfoUrl(url, variantId, shouldFetchFullPage = false) {
    const params = [];

    if (!shouldFetchFullPage) {
      params.push(`section_id=${this.sectionId}`);
    }

    if (variantId) {
      params.push(`variant=${variantId}`);
    } else {
      const optionValues = this.getSelectedOptionValues();
      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(",")}`);
      }
    }

    return `${url}?${params.join("&")}`;
  }

  /**
   * Side-effect API calls (inventory, shelf location, kluslist).
   * Run in PARALLEL instead of sequentially. They are independent of each
   * other and independent of the main DOM update, so we don't await them
   * before showing the new variant info.
   */
  runVariantSideEffectApis(html) {
    const productDetails = html.querySelector(".product-block-product-form");
    if (!productDetails) return;

    const onlineStoreStockCard = document.querySelector(".online-store-inventory");
    const pickupStoreStockCard = document.querySelector(".pickup-store-inventory");

    const storeStockText = window.ShopifyTranslations?.onlineStoreQtyUnavailableText ?? "";
    const pickupStockText = window.ShopifyTranslations?.pickupStoreQtyUnavailableText ?? "";

    if (onlineStoreStockCard) {
      onlineStoreStockCard.innerHTML = `<span class="status-pill unavailable">0</span> ${storeStockText}`;
    }
    if (pickupStoreStockCard) {
      pickupStoreStockCard.innerHTML = `<span class="status-pill unavailable">0</span> ${pickupStockText}`;
    }

    // SKU
    const skuElement = html.querySelector(".product-main-sku > span");
    let productSku = "";
    if (skuElement && !skuElement.closest(".visually-hide")) {
      productSku = skuElement.textContent.trim();
    }
    const hasNumericSku = /^[0-9]+$/.test(productSku);
    const paddedSku = hasNumericSku ? productSku.padStart(10, "0") : "";

    // ASPOS product ID
    let asposProductID = "";
    const productIdElement = html.querySelector(".product-main-sku");
    if (productIdElement && !productIdElement.closest(".visually-hide")) {
      asposProductID = productIdElement?.dataset?.asposproductid || "";
    }

    // Fire all three in parallel; do NOT block UI on them.
    const tasks = [];
    if (paddedSku && typeof productInventoryApi === "function") {
      tasks.push(Promise.resolve().then(() => productInventoryApi(paddedSku)));
    }
    if (typeof productShelfLocationAPI === "function") {
      tasks.push(Promise.resolve().then(() => productShelfLocationAPI(paddedSku, asposProductID)));
    }
    if (typeof kluslistProductDetailPageAPI === "function") {
      tasks.push(Promise.resolve().then(() => kluslistProductDetailPageAPI()));
    }

    // Swallow errors so a single failing API doesn't break the others.
    Promise.allSettled(tasks);
  }

  renderProductInfo(productUrl, targetId, callback) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(productUrl, {
      signal: this.abortController.signal,
    })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        // 1. Run the main DOM update FIRST so the user sees the new
        //    price / stock / form / blocks immediately.
        callback(html);

        // 2. Kick off side-effect APIs in parallel, in the background.
        //    We do NOT await them — they update their own DOM nodes when ready.
        this.runVariantSideEffectApis(html);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("Variant fetch failed:", err);
        }
      });
  }

  handleUpdateProductInfo(sectionId) {
    return (html) => {
      const priceId = `price-${sectionId}`;
      const stockBadgeId = `ProductAvailability-${sectionId}`;
      const headingId = `ProductHeading-${sectionId}`;
      const priceDestination = document.getElementById(priceId);
      const priceSource = html.getElementById(priceId);
      const headingSource = html.getElementById(headingId);
      const headingDestination = document.getElementById(headingId);
      const stockBadgeDestination = document.getElementById(stockBadgeId);
      const stockBadgeSource = html.getElementById(stockBadgeId);
      const productFormSource = html
        .getElementById(`product-form-${sectionId}`)
        ?.closest("product-form");
      const productFormDestination = document
        .getElementById(`product-form-${sectionId}`)
        ?.closest("product-form");
      const productStockBarSource = html.getElementById(`ProductStockBar-${sectionId}`);
      const productStockBarDestination = document.getElementById(`ProductStockBar-${sectionId}`);
      const productSignupSource = html.getElementById(`ProductSignup-${sectionId}`);
      const productSignupDestination = document.getElementById(`ProductSignup-${sectionId}`);
      const productCountdownSource = html.getElementById(`ProductCountdown-${sectionId}`);
      const productCountdownDestination = document.getElementById(`ProductCountdown-${sectionId}`);

      if (priceSource && priceDestination) {
        priceDestination.innerHTML = priceSource.innerHTML;
      }

      if (stockBadgeSource && stockBadgeDestination) {
        stockBadgeDestination.innerHTML = stockBadgeSource.innerHTML;
      }

      // Keep the H1 in sync with the selected variant so the variant
      // attribute stays reflected in the heading when switching client-side.
      if (headingSource && headingDestination) {
        headingDestination.innerHTML = headingSource.innerHTML;
      }

      const price = document.getElementById(`price-${sectionId}`);
      const infoMetas = document.querySelectorAll(`.product-info-meta-${this.dataset.section}`);

      if (price) {
        price.classList.remove("visibility-hidden");
      }

      if (infoMetas.length > 0) {
        infoMetas.forEach((infoMeta) => {
          infoMeta.classList.remove("visibility-hidden");
        });
      }

      if (productFormSource && productFormDestination) {
        productFormDestination.outerHTML = productFormSource.outerHTML;
      }

      if (productStockBarSource && productStockBarDestination) {
        productStockBarDestination.innerHTML = productStockBarSource.innerHTML;
        productStockBarDestination.classList.remove("hidden");
      }

      if (productSignupSource && productSignupDestination) {
        productSignupDestination.outerHTML = productSignupSource.outerHTML;
      }

      if (productCountdownSource && productCountdownDestination) {
        productCountdownDestination.outerHTML = productCountdownSource.outerHTML;
      }

      const blockDestinations = document.querySelectorAll(
        `.product-block-content-${sectionId}.variant-changed-update`,
      );
      const blockSources = html.querySelectorAll(
        `.product-block-content-${sectionId}.variant-changed-update`,
      );

      blockDestinations.forEach((blockDestination, index) => {
        const blockSource = blockSources[index];
        if (blockSource) {
          blockDestination.outerHTML = blockSource.outerHTML;
        } else {
          blockDestination.remove();
        }
      });

      if (blockSources.length > blockDestinations.length) {
        const container = document.querySelector(
          `#ProductPage-${sectionId} .product-info-description-content`,
        );

        if (container) {
          blockSources.forEach((sourceBlock, index) => {
            if (!blockDestinations[index]) {
              const newBlock = sourceBlock.cloneNode(true);
              const nextExistingBlock = blockDestinations[index];

              if (nextExistingBlock && nextExistingBlock.parentNode) {
                nextExistingBlock.parentNode.insertBefore(newBlock, nextExistingBlock);
              } else {
                const lastVariantBlock = container.querySelector(
                  `.product-block-content-${sectionId}.variant-changed-update:last-of-type`,
                );

                if (lastVariantBlock) {
                  lastVariantBlock.after(newBlock);
                } else {
                  const descriptionBlock = container.querySelector(
                    `.product-block-content-${sectionId}.variant-changed-update`,
                  );
                  if (descriptionBlock) {
                    descriptionBlock.after(newBlock);
                  } else {
                    container.prepend(newBlock);
                  }
                }
              }
            }
          });
        }
      }

      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.outOfStock);
      this.setSku(this.currentVariant.sku);
      this.setBarcode(this.currentVariant.barcode);

      this.setProductInfo(html);
      this.updatePickupAvailability();
      this.updateOptionValues(html);

      const event = new CustomEvent("product:variant-change", {
        detail: {
          variant: this.currentVariant,
        },
      });
      document.dispatchEvent(event);

      publish(PUB_SUB_EVENTS.productVariantChange, {
        sectionId: sectionId,
        html,
        variant: this.currentVariant,
      });
    };
  }

  setSku(sku) {
    const skuFields = document.querySelectorAll(`.ProductSku-${this.dataset.section}`);

    if (!skuFields.length) {
      return;
    }

    if (!sku) {
      skuFields.forEach((field) => {
        field.parentNode.classList.add("visually-hidden");
      });
      return;
    }
    skuFields.forEach((field) => {
      field.parentNode.classList.remove("visually-hidden");
      field.textContent = sku;
    });
  }

  setBarcode(barcode) {
    const barcodeFields = document.querySelectorAll(`.ProductBarcode-${this.dataset.section}`);

    if (!barcodeFields.length) {
      return;
    }

    if (!barcode) {
      barcodeFields.forEach((field) => {
        field.parentNode.classList.add("visually-hidden");
      });
      return;
    }

    barcodeFields.forEach((field) => {
      field.parentNode.classList.remove("visually-hidden");
      field.textContent = barcode ?? "";
    });
  }

  setProductInfo(html) {
    const className = `#ProductPage-${this.sectionId} .product-info-details-list`;
    const destinations = document.querySelectorAll(className);
    const sources = html.querySelectorAll(className);

    if (destinations.length > 0) {
      destinations.forEach((destination, index) => {
        if (sources[index]) {
          destination.innerHTML = sources[index]?.innerHTML;
        }
      });
    }
  }

  toggleAddButton(disable = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) {
      return;
    }

    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) {
      return;
    }

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
    } else {
      addButton.removeAttribute("disabled");
    }
  }

  setUnavailable() {
    const form = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = form?.querySelector('[name="add"]');
    const addButtonText = form?.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const product = document.getElementById(`ProductPage-${this.dataset.section}`);
    const infoMetas = document.querySelectorAll(`.product-info-meta-${this.dataset.section}`);
    const stockBarBlock = document.getElementById(`ProductStockBar-${this.dataset.section}`);

    if (addButton) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }

    if (price) {
      price.classList.add("visibility-hidden");
    }

    if (infoMetas.length > 0) {
      infoMetas.forEach((infoMeta) => {
        infoMeta.classList.add("visibility-hidden");
      });
    }

    if (stockBarBlock) {
      stockBarBlock.classList.add("hidden");
    }

    const unavailableDetails = product?.querySelectorAll(
      ".product-info-details-variant-field .product-info-details-item-value",
    );
    if (unavailableDetails) {
      unavailableDetails.forEach((detail) => (detail.innerHTML = "-"));
    }
  }

  getVariantData(inputId) {
    return JSON.parse(
      this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`).textContent,
    );
  }

  getSelectedOptionValues() {
    return Array.from(this.querySelectorAll("select option:checked, fieldset input:checked")).map(
      (element) => element.dataset.optionValueId,
    );
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
}

customElements.define("variant-radios", VariantRadios);

// Product card
//

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.colorSwatches = this.querySelectorAll(".card-product-color-swatch");
    this.productLinks = this.querySelectorAll("a.js-product-link");

    this.colorSwatches.forEach((colorSwatch) => {
      colorSwatch.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleColorSwatchClick(colorSwatch);
      });

      colorSwatch.addEventListener("mouseover", () => {
        this.handleColorSwatchMouseOver(colorSwatch);
      });
    });
  }

  handleColorSwatchClick(colorSwatch) {
    // Set the color swatch to active
    this.colorSwatches.forEach((x) => x.classList.remove("is-active"));
    colorSwatch.classList.add("is-active");

    // Change all links to point to the new URL
    this.productLinks.forEach((productLink) => {
      productLink.setAttribute("href", colorSwatch.getAttribute("href"));
    });

    // Change the image
    const variantImageTemplate = colorSwatch.querySelector(".card-media-image");
    const mainImage = this.querySelector(".card-media img:first-child");
    if (variantImageTemplate && mainImage) {
      const variantImage = variantImageTemplate.cloneNode(true);
      variantImage.classList.remove("card-variant-image");
      mainImage.replaceWith(variantImage);
    }

    // Update the SKU
    const variantSku = colorSwatch.getAttribute("data-variant-sku");
    const skuElement = this.querySelector("[data-card-sku]");
    if (skuElement) {
      skuElement.textContent = variantSku || "";
    }
    const wishlistButton = this.querySelector("[class*='add-variation-kluslist-']");
    if (wishlistButton) {
      wishlistButton.dataset.productSku = variantSku || "";
    }
  }

  handleColorSwatchMouseOver(colorSwatch) {
    const image = colorSwatch.querySelector(".card-media-image");
    // Preload the image on mouseover
    if (image) {
      image.style.display = "inline-block";
      image.setAttribute("loading", "");
    }
  }
}

customElements.define("product-card", ProductCard);

// Expandable list
//
class ExpandableList extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      root: this.querySelector("ul"),
      expandableNavs: this.querySelectorAll(".has-sub-menu"),
      expandableToggles: this.querySelectorAll(".navigation-side-toggle"),
    };

    if (!this.elements.expandableNavs.length) {
      return;
    }

    this.expandOnArrowsOnly = this.getAttribute("expand-on-arrows") === "true";

    if (!this.expandOnArrowsOnly) {
      this.elements.expandableNavs.forEach((nav) => {
        const navLink = nav.querySelector("a");
        navLink.addEventListener("click", this.onToggle.bind(this, nav));
      });
    }
    this.elements.expandableToggles.forEach((toggle) => {
      const nav = toggle.closest(".navigation-side-item");
      toggle.addEventListener("click", this.onToggle.bind(this, nav));
    });
  }

  onToggle(navElement, event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const submenu = navElement.querySelector("ul");
    const closeOthers = this.getAttribute("close-others");
    const isExpanded = submenu.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      this.onContract(navElement);
    } else {
      this.onExpand(navElement);

      if (closeOthers) {
        const closestRoot = navElement.closest("ul");
        const siblings = [...closestRoot.querySelectorAll(":scope > .has-sub-menu")].filter(
          (item) => {
            return item !== navElement;
          },
        );
        siblings.forEach(this.onContract);
      }
    }
  }

  onExpand(element) {
    const submenu = element.querySelector("ul");
    const toggle = element.querySelector(".navigation-side-toggle");
    element.classList.add("is-expanded");
    submenu.setAttribute("aria-expanded", "true");
    if (toggle) {
      toggle.setAttribute("aria-expanded", "true");
      toggle.querySelector("span.visually-hidden").innerHTML = toggle.dataset.collapseText;
    }
  }

  onContract(element) {
    const submenu = element.querySelector("ul");
    const toggle = element.querySelector(".navigation-side-toggle");
    element.classList.remove("is-expanded");
    submenu.setAttribute("aria-expanded", "false");
    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
      toggle.querySelector("span.visually-hidden").innerHTML = toggle.dataset.expandText;
    }
  }
}

customElements.define("expandable-list", ExpandableList);

// Quantity Input
//
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );

    this.pricingTiers = this.parsePricingTiers();
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.updateTierPriceDisplay();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  parsePricingTiers() {
    const script = this.querySelector('script[type="application/json"][data-pricing-tiers]');
    if (!script) return null;

    try {
      const tiers = JSON.parse(script.textContent);
      if (!Array.isArray(tiers) || !tiers.length) return null;

      // Sort ascending by minimum_quantity so lookup can walk forward and stop early
      return tiers
        .filter((t) => t && typeof t.minimum_quantity === "number")
        .sort((a, b) => a.minimum_quantity - b.minimum_quantity);
    } catch (err) {
      console.warn("[QuantityInput] Failed to parse pricing tiers JSON:", err);
      return null;
    }
  }

  formatPriceNL(price) {
    return Number(price).toFixed(2).replace(".", ",");
  }

  getTierMessage(qty) {
    if (!this.pricingTiers || !this.pricingTiers.length) return null;

    // Find the first tier whose minimum_quantity the qty has NOT yet reached.
    const nextTier = this.pricingTiers.find((tier) => qty < tier.minimum_quantity);

    // If every tier has already been reached, show the last (highest) tier.
    const tierToShow = nextTier || this.pricingTiers[this.pricingTiers.length - 1];

    const formattedPrice = this.formatPriceNL(tierToShow.price);
    const unitLabel = tierToShow.minimum_quantity === 1 ? "stuk" : "stuks";

    return `€ ${formattedPrice} vanaf ${tierToShow.minimum_quantity} ${unitLabel}`;
  }

  getActiveTier(qty) {
    if (!this.pricingTiers || !this.pricingTiers.length) return null;

    let active = null;
    for (const tier of this.pricingTiers) {
      if (qty >= tier.minimum_quantity) {
        active = tier;
      } else {
        break;
      }
    }
    return active;
  }

  getTierPriceForQuantity(qty) {
    const tier = this.getActiveTier(qty);
    return tier ? tier.price : null;
  }

  updateTierPriceDisplay() {
    if (!this.pricingTiers) return;

    const qty = parseInt(this.input.value, 10) || 1;
    const tier = this.getActiveTier(qty);
    const message = this.getTierMessage(qty);

    const lineItem = this.closest(".js-cart-item") || this.closest("[id^='MiniCartItem-']");
    if (!lineItem) return;

    const summaryWrapper = lineItem.querySelector(".mini-cart-bulk-summary-wrapper .bulk-summary");
    if (!summaryWrapper) return;

   summaryWrapper.textContent = message;
    summaryWrapper.classList.remove("hidden"); 

    this.dispatchEvent(
      new CustomEvent("quantity-input:pricing-tier-change", {
        bubbles: true,
        detail: { quantity: qty, tier },
      }),
    );
  }

  onInputChange(event) {
    // clamp typed values to the stock max before cart listeners read them;
    // bulk/quick-order inputs show their own max error, so leave them raw
    if (this.closest("cart-items") || this.closest("mini-cart")) {
      const max = parseInt(this.input.max, 10);
      if (max > 0 && parseInt(this.input.value, 10) > max) {
        this.input.value = max;
      }
    }
    this.validateQtyRules();
    this.checkBackorderNotice();
    this.updateTierPriceDisplay();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    // Use currentTarget (the <button> the listener is bound to), NOT target: the
    // button wraps a visually-hidden <span>, and a click landing on that span makes
    // event.target the span (no `name`), which silently fell through to stepDown() —
    // so pressing "+" intermittently DECREASED the quantity. currentTarget is always
    // the button, so +/- is now deterministic regardless of where inside it you click.
    const buttonName = event.currentTarget.name;

    if (buttonName === "plus") {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);

      const event = new CustomEvent("product:quantity-update", {
        detail: {
          quantity: Number(this.input.value),
        },
      });
      document.dispatchEvent(event);
    }

    if (this.input.dataset.min === previousValue && buttonName === "minus") {
      this.input.value = parseInt(this.input.min);
    }

    this.checkBackorderNotice();

  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector("button[name='minus']");
      if(buttonMinus){
        buttonMinus.classList.toggle("disabled", parseInt(value) <= parseInt(this.input.min));
      }
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector("button[name='plus']");
      if(buttonPlus){
        buttonPlus.classList.toggle("disabled", value >= max);       
      }
    }
  }

  // added for check order notice on PDP, if the stock is 0 or the quantity exceeds the stock, show the backorder notice if enabled in theme settings
  checkBackorderNotice() {
      // PDP-only feature. On the cart / mini-cart these quantity inputs have no
      // backorder wrapper, so skip silently instead of logging on every render.
      if (this.closest('cart-items') || this.closest('mini-cart')) {
          return;
      }

      const wrapper = document.querySelector('.product-backorder-wrapper');
      if (!wrapper) {
          console.log('[BackorderNotice] No .product-backorder-wrapper found — skipping');
          return;
      }

      if (typeof _currentOnlineStoreStock === 'undefined' || _currentOnlineStoreStock === null) {
          console.log('[BackorderNotice] _currentOnlineStoreStock is not set yet — skipping');
          return;
      }

      const shouldShow = wrapper.dataset.backorderShowBackorder === 'true';
      const inputQty = parseInt(this.input.value) || 1;

      // Use the higher of online stock and pickup stock as the threshold.
      // If _currentPickStoreStock is not yet set, fall back to 0 so it
      // doesn't artificially inflate the max.
      const onlineStock = parseInt(_currentOnlineStoreStock) || 0;
      const pickupStock = (typeof _currentPickStoreStock !== 'undefined' && _currentPickStoreStock !== null)
          ? parseInt(_currentPickStoreStock) || 0
          : 0;
      const stock = Math.max(onlineStock, pickupStock);

      const isOutOfStock = stock <= 0;
      const qtyExceedsStock = inputQty > stock;
      const willShow = shouldShow && (isOutOfStock || qtyExceedsStock);

      console.log('[BackorderNotice] checkBackorderNotice() called');
      console.log('[BackorderNotice] shouldShow (customer eligible + block enabled):', shouldShow);
      console.log('[BackorderNotice] inputQty:', inputQty);
      console.log('[BackorderNotice] onlineStock:', onlineStock);
      console.log('[BackorderNotice] pickupStock:', pickupStock);
      console.log('[BackorderNotice] effectiveStock (max):', stock);
      console.log('[BackorderNotice] isOutOfStock:', isOutOfStock);
      console.log('[BackorderNotice] qtyExceedsStock:', qtyExceedsStock);
      console.log('[BackorderNotice] willShow:', willShow);

      wrapper.style.display = willShow ? '' : 'none';

      // Swap title and paragraph based on reason
      if (willShow) {
          const titleEl = wrapper.querySelector('.backorder-notice__title');
          const paragraphEl = wrapper.querySelector('.backorder-notice__paragraph');

          if (qtyExceedsStock && !isOutOfStock) {
              // Qty exceeds stock — inject actual stock number into the title
              const qtyExceedsTitle = window.themeStrings.back_order_form.qty_exceeds_stock
                  .replace('{{qty_exceeds}}', stock);

              if (titleEl) titleEl.textContent = qtyExceedsTitle;
              if (paragraphEl) paragraphEl.textContent = window.themeStrings.back_order_form.qty_exceeds_para;
              console.log('[BackorderNotice] reason: qty_exceeds — swapped title with stock:', stock);
          } else {
              // Out of stock — restore original title and paragraph from data attributes
              if (titleEl) titleEl.textContent = titleEl.dataset.titleOutOfStock;
              if (paragraphEl) paragraphEl.textContent = paragraphEl.dataset.paragraphOutOfStock;
              console.log('[BackorderNotice] reason: out_of_stock — restored original title and paragraph');
          }
      }

      console.log('[BackorderNotice] wrapper.style.display set to:', wrapper.style.display === '' ? '(visible)' : 'none');
  }
}

customElements.define("quantity-input", QuantityInput);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-items");
      const miniCart = this.closest("mini-cart");

      // Address the exact line by its unique key (falls back to variant id).
      // A variant id is ambiguous when the same variant exists in two lines.
      const removeRef = this.dataset.key || this.dataset.variantId;

      if (cartItems) {
        window.showPageLoader();
        cartItems.updateQuantity(removeRef, 0);

        const quoteWrapper = document.querySelector('.quotation_event_main_wrapper');
        if(quoteWrapper) {
          quoteWrapper.innerHTML = '';
          quoteWrapper.style.display = "none";
        }
        const quoteSidebarWrapper = document.querySelector('.quotation_event_main_sidebar_wrapper');
        if(quoteSidebarWrapper) {
          quoteSidebarWrapper.innerHTML = '';
          quoteSidebarWrapper.style.display = "none";
        }
      }

      if (miniCart) {
        miniCart.updateQuantity(removeRef, 0);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  _renderVersion = 0;

  constructor() {
    super();
    this.eventContext = this.dataset.eventContext;
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status");

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0,
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 500);

    // Keep the two per-line views (mobile + desktop — same data-key) in lock-step
    // the INSTANT either changes: synchronously, BEFORE the debounced network write
    // below. This makes the pair a single source of truth per line, so the
    // un-clicked twin can never hold a stale value and emit a reverting "echo".
    this.addEventListener("change", this.syncLineViews.bind(this));
    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  // If a quantity change failed at the edge 429 checkpoint and reloaded the
  // page, replay it now that navigation has cleared the checkpoint. The line
  // index is still valid because the failed change never applied.
  connectedCallback() {
    if (!window.CartRecovery) return;
    // A successful (re)load means any qty section-render reload has done its job —
    // reset that budget so a later, unrelated 429 gets its full reload allowance.
    window.CartRecovery.clearReplay("qty_render");
    const replay = window.CartRecovery.getReplay("qty");
    // Accept the new key-based payload (lineRef) and the legacy variantId payload
    // (an entry persisted by an older build before a reload).
    const replayRef = replay ? (replay.lineRef != null ? replay.lineRef : replay.variantId) : null;
    if (replayRef == null) return;
    const run = () => this.updateQuantity(replayRef, replay.quantity);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", run, { once: true });
    } else {
      run();
    }
  }

  // Mirror the changed value onto every input that shares this line's data-key —
  // i.e. the mobile + desktop views of ONE line. Runs synchronously on the raw
  // `change` (not debounced), so both views are already identical before the twin
  // can emit its own stale `change`. Addressed purely by data-key: it is unique
  // per line and identical across its two views, so this touches exactly this
  // line's pair and never another row (even a duplicate of the same variant).
  syncLineViews(event) {
    const input = event.target;
    if (input.name !== "updates[]" || input.closest("cart-coupon")) return;
    const lineKey = input.dataset.key;
    if (!lineKey) return;
    const value = input.value;
    this.querySelectorAll(`[name="updates[]"][data-key="${lineKey}"]`).forEach((twin) => {
      if (twin !== input) twin.value = value;
    });
  }

  onChange(event) {
    const input = event.target;

    // Only react to quantity inputs. Cart-policy checkbox, coupon field and the
    // delivery-method radios also bubble a `change` up to this element — ignore them.
    if (
      input.name !== "updates[]" ||
      input.getAttribute("id")?.includes?.("cart-policy") ||
      input.closest("cart-coupon")
    ) {
      return;
    }

    // Input removed from the DOM between the user action and this debounced
    // callback (e.g. a re-render) → its data is stale; skip silently.
    if (!input.isConnected) return;

    // Address the line SOLELY by its unique data-key — rendered on every cart row
    // and identical across the line's mobile + desktop views. No variant-id / id
    // fallback: keying only on data-key keeps duplicate-variant lines unambiguous
    // (two lines of one variant share a variant id but have DIFFERENT keys). If a
    // row somehow lacks data-key, bail rather than risk targeting the wrong line.
    const lineKey = input.dataset.key;
    if (!lineKey) return;
    const lineRef = lineKey;
    const newValue = input.value;

    // Dedup only — correctness now comes from syncLineViews() keeping both views
    // in lock-step. Skip when the line is already at this quantity: because the two
    // views are always value-synced, any stray "echo" change carries the CURRENT
    // value, so this drops it as a no-op instead of reverting the quantity (the old
    // stale-echo bug). A genuine re-entry of the same value is a real no-op too.
    // Purely to avoid a redundant /cart/update.js (429 pressure).
    const cartLine = window.CartStore?.peek?.()?.items?.find((i) => i.key === lineKey);
    if (cartLine && String(cartLine.quantity) === String(newValue)) return;

    this.updateQuantity(
      lineRef,
      newValue,
      document.activeElement.getAttribute("name"),
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-page-title-wrap",
        section: document.getElementById("cart-page-title-wrap")?.dataset.id,
        selector: ".page-title-wrap",
      },
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "header",
        section: document.getElementById("header")?.dataset.id,
        selector: ".head-slot-cart-link",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "mobile-dock",
        section: document.getElementById("mobile-dock")?.dataset.id,
        selector: ".head-slot-cart-link",
      },
    ].filter((section) => {
      const element = document.getElementById(section.id);
      return element && (section.selector ? element.querySelector(section.selector) : true);
    });
  }

  updateQuantity(lineRef, quantity, name) {
    // lineRef is a line-item KEY ("NNNN:hex") when available, else a bare variant
    // id (legacy fallback). A key is unique per line, so it disambiguates two
    // lines that share the same variant — the case a variant id cannot handle.
    const _isKey = typeof lineRef === "string" && lineRef.indexOf(":") !== -1;
    // Resolve the CURRENT DOM line (1-based data-index) of the row holding this
    // line — used only for the loading overlay shown before the response
    // arrives. The authoritative line is recomputed from the response below.
    const _domInput = this.querySelector(
      _isKey
        ? `[name="updates[]"][data-key="${lineRef}"]`
        : `[name="updates[]"][data-variant-id="${lineRef}"]`
    );
    let line = _domInput ? _domInput.dataset.index : undefined;
    console.log("[CartItems.updateQuantity] called — lineRef:", lineRef, "quantity:", quantity, "name:", name, "domLine:", line);
    this.enableLoading(line);

    const body = JSON.stringify({
      // Update by line KEY via /cart/update.js `updates` map (key → quantity).
      // We deliberately do NOT use /cart/change.js here: change.js addressed by a
      // line-item key ("id": "<variantid>:<hash>") returns 400 in this store's
      // Shopify build. update.js reliably accepts line keys — it's the same call
      // PalletManager uses to remove pallet/surcharge lines by item.key. The key
      // is unique per line, so it disambiguates two lines sharing a variant, which
      // a variant id or a stale positional line index cannot. Quantity is coerced
      // to a Number (the input value is a string). Falls back to lineRef = variant
      // id when a row has no data-key (also a valid updates key).
      updates: { [lineRef]: Number(quantity) },
      // Dedupe: cart-page-title-wrap and main-cart-items share one section id, so
      // the same section would otherwise be requested twice in one POST.
      sections: [...new Set(this.getSectionsToRender().map((section) => section.section))],
      sections_url: window.location.pathname,
    });

    const _cartFetch = (window.CartQueue ? window.CartQueue.fetch : fetch);
    _cartFetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body }, failFastOn429: true })
      .then((response) => {
        // Edge bot-protection checkpoint (429): the body is an HTML challenge,
        // not JSON. Reload to re-pass it, then replay this exact quantity change
        // on load — the variant id is still valid because the change did NOT
        // apply. Capped at 2 reloads by CartRecovery.
        if (response.status === 429 && window.CartRecovery) {
          if (window.CartRecovery.reloadAndReplay("qty", { lineRef: lineRef, quantity: quantity })) {
            return null; // page is reloading
          }
          this.setError(window.cartStrings.error); // reload budget spent
          return null;
        }
        return response.text();
      })
      .then(async (state) => {
        if (state === null) return; // 429 handled above (reloading or errored)
        const parsedState = JSON.parse(state);
        // Recompute the authoritative 1-based line of the updated variant from the
        // response. All positional bookkeeping below (DOM ids, array access, focus)
        // uses this real line, which matches the freshly re-rendered sections.
        const _realIdx = (parsedState.items || []).findIndex(i =>
          _isKey ? i.key === lineRef : String(i.variant_id) === String(lineRef));
        if (_realIdx >= 0) line = _realIdx + 1;
        console.log("[CartItems.updateQuantity] /cart/update.js response — item_count:", parsedState.item_count, "errors:", parsedState.errors, "status:", parsedState.status);
        console.log("[CartItems.updateQuantity] lineRef", lineRef, "resolved to REAL cart line:", line);
        const items = document.querySelectorAll(".js-cart-item");

        if (parsedState.errors || (parsedState.status && parsedState.status >= 400)) {
          console.warn("[CartItems.updateQuantity] ERROR from /cart/update.js — triggering section re-render. errors:", parsedState.errors, "description:", parsedState.description);
          // 400 most commonly means a stale line index (e.g. PalletManager shifted
          // line numbers between the user interaction and the debounced fetch).
          // Refresh sections so the cart re-renders with correct indices.
          // failFast=true so a 429 here surfaces to .catch → reload (the change
          // didn't apply in this branch) instead of stalling ~15s on backoff.
          await this.updateSectionContents(true);
          this.updateLiveRegions(line, parsedState.description || parsedState.errors || window.cartStrings.error, lineRef);
          return;
        }

        // Quantity change applied — clear any pending 429 reload-replay.
        if (window.CartRecovery) window.CartRecovery.clearReplay("qty");

        // Warm CartStore from the authoritative /cart/change response BEFORE any
        // rendering (which can throw, e.g. null sections). This guarantees the
        // post-update inventory pass (.finally → cartProductInventoryAPI →
        // cart:inventory:updated → updateDeliveryPriceUI → fetchCart) reads from
        // cache and never fires a racing GET /cart.js that the edge checkpoint
        // would 429.
        if (window.CartStore && typeof window.CartStore.setCache === "function") {
          window.CartStore.setCache(parsedState);
        }

        /* RECALCULATE PALLET AFTER QTY UPDATE — skip for Store-Pickup (no pallets needed) */
        const _currentDeliveryMethod = document.querySelector('input[name="delivery_option"]:checked')?.value;
        console.log("[CartItems.updateQuantity] deliveryMethod:", _currentDeliveryMethod, "— calling PalletManager.sync()");
        const palletChanged = _currentDeliveryMethod !== 'Store-Pickup' ? await PalletManager.sync() : false;
        console.log("[CartItems.updateQuantity] PalletManager.sync() result — palletChanged:", palletChanged);

        let freshCart = null;
        if (palletChanged) {
          // Pallet was removed/updated — fetch fresh sections that reflect both changes.
          // failFast=true so a 429 surfaces to .catch → reload instead of stalling on
          // CartQueue backoff. The change.js write already committed, so .catch reloads
          // WITHOUT replaying the quantity (reload re-fetches the correct sections).
          await this.updateSectionContents(true);
          freshCart = await window.CartStore.refresh();
          const isEmpty = freshCart.item_count === 0;
          this.classList.toggle("is-empty", isEmpty);
          const cartFooter = document.getElementById("main-cart-footer");
          if (cartFooter) cartFooter.classList.toggle("is-empty", isEmpty);
          document.querySelectorAll('.mini-cart-count').forEach(el => {
            el.textContent = `(${freshCart.item_count})`;
          });
        } else {
          // No pallet change — render directly from the already-returned parsedState.
          // Bump _renderVersion so any older, still-in-flight updateSectionContents()
          // (e.g. from a prior remove / delivery switch) is DISCARDED when it resolves
          // instead of overwriting this fresher state — the stale-render race that
          // made a quantity "snap back" after another cart action.
          this._renderVersion++;
          this.classList.toggle("is-empty", parsedState.item_count === 0);
          const cartFooter = document.getElementById("main-cart-footer");
          if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const container = document.getElementById(section.id);
            const elementToReplace = container?.querySelector(section.selector) || container;
            if (elementToReplace && parsedState.sections?.[section.section] != null) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              );
            }
          });

          document.querySelectorAll('.mini-cart-count').forEach((el) => {
            el.textContent = `(${parsedState.item_count})`;
          });
        }

        // When palletChanged=true, freshCart reflects the true post-sync state.
        // Using it for events ensures cart:item-remove correctly identifies an
        // empty cart (parsedState may still count the pallet that was just removed).
        const cartForEvents = freshCart || parsedState;

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantity)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace("[quantity]", updatedValue);
          }
        }
        this.updateLiveRegions(line, message, lineRef);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`MiniCartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          lineItem.querySelector(`[name="${name}"]`).focus();
        }

        if (quantity === 0) {
          const event = new CustomEvent("cart:item-remove", {
            detail: {
              cart: cartForEvents,
              context: this.eventContext,
            },
          });
          document.dispatchEvent(event);
        } else {
          const event = new CustomEvent("cart:item-quantity-update", {
            detail: {
              cart: cartForEvents,
              context: this.eventContext,
            },
          });
          document.dispatchEvent(event);
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: cartForEvents,
          variantId: cartForEvents.items[line - 1]?.id,
        });
      })
      .catch((err) => {
        // The change.js POST already succeeded; a 429 reaching here came from the
        // follow-up section re-render (updateSectionContents) hitting the edge
        // checkpoint. Reload to re-pass it and fetch fresh sections — do NOT replay
        // the quantity change (it already committed; replaying would double-apply).
        if (window.CartRecovery && window.CartRecovery.is429(err)) {
          if (window.CartRecovery.reloadAndReplay("qty_render", {})) return; // reloading
        }
        this.setError(window.cartStrings.error);
      })
      .finally(() => {
        this.disableLoading();
        cartProductInventoryAPI();
        miniCartProductInventoryAPI();
      });
  }

  setError(error) {
    document.getElementById("cart-errors").textContent = error;
  }

  updateLiveRegions(line, message, lineKey) {
    // Each line renders TWO error blocks (mobile + desktop) that historically
    // shared one duplicate id, so getElementById only ever wrote to the mobile
    // one and the desktop view showed no error. Address by data-key to write the
    // message into BOTH views; fall back to the id only when no key is supplied.
    const errorBlocks = lineKey
      ? Array.from(this.querySelectorAll(`.cart-item-error[data-key="${lineKey}"]`))
      : [document.getElementById(`Line-item-error-${line}`)].filter(Boolean);

    errorBlocks.forEach((block) => {
      const el = block.querySelector(".cart-item-error-text");
      if (el) el.innerHTML = message;
    });

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  updateSectionContents() {
    const version = ++this._renderVersion;
    const _cartFetch = (window.CartQueue ? window.CartQueue.fetch : fetch);
    // When called with failFastOn429 (e.g. a recommendation add on the cart
    // page), skip CartQueue's retry/backoff and surface the 429 so the caller
    // can recover (reload past the edge checkpoint) instead of stalling ~15s.
    const failFast = arguments.length > 0 && arguments[0] === true;
    const init = failFast ? { failFastOn429: true } : undefined;
    // Shopify rate-limits /search per IP, and every search page load already
    // spends requests from that bucket. The header/mini-cart sections are
    // global, so on search pages render them from the root path instead —
    // keeps this call out of the /search rate-limit bucket.
    const sectionBasePath = window.location.pathname.startsWith("/search")
      ? "/"
      : window.location.pathname;
    return _cartFetch(
      `${sectionBasePath}?sections=${[...new Set(this.getSectionsToRender()
        .map((section) => section.section))]
        .join(",")}&v=${Date.now()}`,
      init,
    )
      .then((response) => {
        if (response.status === 429) {
          const err = new Error("cart-section-render-429");
          err.status = 429;
          throw err;
        }
        return response.json();
      })
      .then((response) => {
        // Discard stale renders: if a newer updateSectionContents() call has
        // already committed its result, skip this older one so it cannot
        // overwrite a fresher cart state (e.g. page-load pallet sync racing
        // with a user-initiated remove).
        if (this._renderVersion !== version) return;
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            response[section.section],
            section.selector,
          );
        });
      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById("main-cart-items").classList.add("cart-items-disabled");
    this.querySelectorAll(`#CartItem-${line} .cart-item-loading-overlay`).forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );
    // Fade out + disable the +/- quantity buttons while the update is in flight.
    this.querySelectorAll(".quantity-input-button").forEach((btn) => {
      btn.classList.add("disabled");
      btn.setAttribute("disabled", "");
    });
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    document.getElementById("main-cart-items").classList.remove("cart-items-disabled");
    this.querySelectorAll(".cart-item-loading-overlay").forEach((overlay) =>
      overlay.classList.add("hidden"),
    );
    // Re-enable the +/- quantity buttons once the update settles.
    this.querySelectorAll(".quantity-input-button").forEach((btn) => {
      btn.classList.remove("disabled");
      btn.removeAttribute("disabled");
    });
  }
}

customElements.define("cart-items", CartItems);

class MiniCart extends CartItems {
  constructor() {
    super();
    this.toggle = this.querySelector("drawer-toggle");
  }

  connectedCallback() {
    if (!Shopify.designMode) {
      this.updateSectionContents().then(() => {
        // re-render wipes the stock max caps — restore from cache
        if (typeof applyMiniCartQuantityMax === "function") applyMiniCartQuantityMax();
      });
    }

    window.miniCart = this;

    // Listen to global events from apps
    document.addEventListener("open-mini-cart", (e) => {
      this.open(e.detail?.opener || null);
    });
    document.addEventListener("close-mini-cart", () => {
      this.close();
    });
    document.addEventListener("toggle-mini-cart", (e) => {
      const opener = e.detail?.opener || null;
      if (this.toggle?.hasAttribute("open")) {
        this.close();
      } else {
        this.open(opener);
      }
    });
  }

  open(opener) {
    this.toggle.open(opener);
    this.dispatchEvent(new CustomEvent("mini-cart:opened", { bubbles: true }));
  }

  close() {
    this.toggle.close();
    this.dispatchEvent(new CustomEvent("mini-cart:closed", { bubbles: true }));
  }

  getSectionsToRender() {
    return [
      {
        id: "header",
        section: document.getElementById("header")?.dataset.id,
        selector: ".head-slot-cart-link",
      },
      {
        id: "header-mini-cart-content",
        section: "header-mini-cart-content",
      },
      {
        id: "header-mini-cart-footer",
        section: "header-mini-cart-footer",
      },
      {
        id: "mobile-dock",
        section: document.getElementById("mobile-dock")?.dataset.id,
        selector: ".head-slot-cart-link",
      },
    ].filter((section) => {
      const element = document.getElementById(section.id);
      return element && (section.selector ? element.querySelector(section.selector) : true);
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const found = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    return found ? found.innerHTML : null;
  }

  renderContents(parsedState) {
    // /cart/add.js can return `sections: null` in some contexts (e.g. adding a
    // recommendation from the cart page), so guard before touching it.
    const sections = parsedState && parsedState.sections;
    if (sections) {
      this.getSectionsToRender().forEach((section) => {
        const sectionHTML = sections[section.section];
        if (sectionHTML == null) return; // section not in this response — skip

        const container = document.getElementById(section.id);
        if (!container) return; // target not on this page — skip

        const elementToReplace = container.querySelector(section.selector) || container;
        const innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
        if (innerHTML != null) elementToReplace.innerHTML = innerHTML;
      });
    }
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0,
    );

    // Sync the cart count badge. /cart/add.js returns the line item (no
    // item_count), so when item_count isn't on parsedState we fetch /cart.js
    // to get the authoritative count. When it IS on parsedState (e.g. a
    // caller passing a full cart object) we use it directly — no extra request.
    if (typeof parsedState.item_count === "number") {
      document.querySelectorAll(".mini-cart-count").forEach((el) => {
        el.textContent = `(${parsedState.item_count})`;
      });
    } else {
      window.CartStore.get()
        .then((cart) => {
          document.querySelectorAll(".mini-cart-count").forEach((el) => {
            el.textContent = `(${cart.item_count})`;
          });
        })
        .catch(() => { /* non-fatal */ });
    }

  }

  setError(error) {
    document.getElementById("mini-cart-error").textContent = error;
  }

  enableLoading() {
    this.querySelector(".mini-cart-wrap").classList.add("loading");
  }

  disableLoading() {
    this.querySelector(".mini-cart-wrap").classList.remove("loading");
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`MiniCart-Line-item-error-${line}`);
    if (lineItemError) {
      lineItemError.querySelector(".cart-item-error-text").innerHTML = message;
    }
  }
}

customElements.define("mini-cart", MiniCart);

// Language & Country selectors.
//
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector("button"),
      dropdown: this.querySelector(".dropdown"),
      panel: this.querySelector(".dropdown-list-wrap"),
    };
    this.elements.button.addEventListener("click", this.openSelector.bind(this));
    this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this)),
    );
  }

  hidePanel() {
    this.elements.button.blur();
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("aria-hidden", "true");
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") {
      return;
    }

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
      form.submit();
    }
  }

  toggleSelector() {
    if (this.isOpen()) {
      this.hidePanel();
      return;
    }

    this.elements.button.focus();
    this.elements.panel.setAttribute("aria-hidden", "false");
    this.elements.button.setAttribute("aria-expanded", "true");
  }

  isOpen() {
    return this.elements.panel.getAttribute("aria-hidden") === "false";
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.setAttribute(
      "aria-hidden",
      this.elements.button.getAttribute("aria-hidden") === "true",
    );
    this.elements.button.setAttribute(
      "aria-expanded",
      (this.elements.button.getAttribute("aria-expanded") === "false").toString(),
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget &&
      (event.relatedTarget.nodeName === "BUTTON" || event.relatedTarget.nodeName === "MAIN");
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

class TabsComponent extends HTMLElement {
  constructor() {
    super();
  }

  setActiveTab(handle) {
    this.querySelectorAll("[data-handle]").forEach((tab) => {
      tab.setAttribute("aria-hidden", "true");

      if (tab.getAttribute("data-handle") === handle) {
        const carouselComponent = tab.querySelector("carousel-slider");
        tab.setAttribute("aria-hidden", "false");

        if (carouselComponent) {
          carouselComponent.flickity.resize();
        }
      }
    });
  }
}

customElements.define("tabs-component", TabsComponent);

class TabsNavigation extends HTMLElement {
  constructor() {
    super();

    this.sliderId = this.getAttribute("for");
    this.navs = this.querySelectorAll("a, button");
    this.navs.forEach((nav) => {
      nav.addEventListener("click", this.onNavigationClick.bind(this, nav));
    });
  }

  onNavigationClick(element, event) {
    event.preventDefault();
    this.setActiveTab(element);
  }

  setActiveTab(nav) {
    const target = nav.getAttribute("data-handle");
    const tabsComponent = document.querySelector(`#${this.sliderId}`);

    if (!tabsComponent) {
      return;
    }

    tabsComponent.setActiveTab(target);

    this.navs.forEach((element) => {
      if (element === nav) {
        element.classList.add("is-active");
      } else {
        element.classList.remove("is-active");
      }
    });
  }
}

customElements.define("tabs-navigation", TabsNavigation);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');

    if (!poster) {
      return;
    }

    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();

    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) {
        deferredElement.focus();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

// Drawers
//
class DrawerModal extends HTMLElement {
  constructor() {
    super();
    this.bodyClass = this.getAttribute("body-class");
    this.isOpen = false;
    this.eventPrefix = this.dataset.eventPrefix;

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        if (this.isOpen) {
          this.close();
        }
      }
    });
  }

  open(opener) {
    this.isOpen = true;
    this.openedBy = opener;
    document.body.classList.add(this.bodyClass);
    document.body.classList.add("drawer-open");

    if (this.eventPrefix) {
      const event = new CustomEvent(`${this.eventPrefix}:open`);
      document.dispatchEvent(event);
    }
  }

  close() {
    this.isOpen = false;
    document.body.classList.remove(this.bodyClass);
    document.body.classList.remove("drawer-open");

    if (this.openedBy) {
      removeTrapFocus(this.openedBy);
    }

    if (this.eventPrefix) {
      const event = new CustomEvent(`${this.eventPrefix}:close`);
      document.dispatchEvent(event);
    }
  }
}

customElements.define("drawer-modal", DrawerModal);

class DrawerToggle extends HTMLElement {
  constructor() {
    super();
    this.toggleElement = this.querySelector("a") || this.querySelector("button");
    this.bodyClass = this.getAttribute("body-class");
    this.preventOpen = this.getAttribute("prevent-open") === "true";
    this.eventPrefix = this.dataset.eventPrefix;

    if (this.preventOpen) {
      return;
    }

    this.toggleElement.addEventListener("click", (event) => {
      event.preventDefault();
      this.handleToggle();
    });
  }

  handleToggle(opener) {
    const drawer = document.querySelector(`#${this.getAttribute("for")}`);

    if (drawer.isOpen) {
      this.close();
    } else {
      this.open(opener);
    }
  }

  open(opener) {
    const drawer = document.querySelector(`#${this.getAttribute("for")}`);

    if (drawer) {
      drawer.open(opener || this.toggleElement);
      const drawerHeader = drawer.querySelector(".drawer-header");
      trapFocus(drawer, drawerHeader);
    }
  }

  close() {
    const drawer = document.querySelector(`#${this.getAttribute("for")}`);

    if (drawer && drawer.close && drawer.isOpen) {
      drawer.close();
    }
  }
}

customElements.define("drawer-toggle", DrawerToggle);

class CartConsentCheckbox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const CART_CONSENT_CHECKBOX_VALUE = "_CART_CONSENT_CHECKBOX_";
    const checkbox = this.querySelector('[type="checkbox"]');

    if (localStorage.getItem(CART_CONSENT_CHECKBOX_VALUE) === "checked") {
      checkbox.setAttribute("checked", true);
    }

    checkbox.addEventListener("change", function () {
      if (this.checked) {
        localStorage.setItem(CART_CONSENT_CHECKBOX_VALUE, "checked");
      } else {
        localStorage.removeItem(CART_CONSENT_CHECKBOX_VALUE);
      }
    });
  }
}

customElements.define("cart-consent-checkbox", CartConsentCheckbox);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  updateMultipleQty(items) {
    // Subclassed method.
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace("[min]", event.target.dataset.min),
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace("[max]", event.target.max),
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace("[step]", event.target.step),
      );
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      event.target.setAttribute("value", inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
}

if (!customElements.get("bulk-add")) {
  customElements.define("bulk-add", BulkAdd);
}

if (!customElements.get("quick-add-bulk")) {
  customElements.define(
    "quick-add-bulk",
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector("quantity-input");
        this.revealHeader = this.dataset.revealHeader === "true";
        this.triggerCart = this.dataset.triggerCart === "true";

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
          } else {
            this.validateQuantity(event);
          }
        }, 300);

        this.addEventListener("change", debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const quantity = parseInt(this.input.value, 10);
          if (
            event.source === "quick-add" ||
            (quantity === 0 &&
              event.cartData.items &&
              !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
            (quantity === 0 &&
              event.cartData.variant_id &&
              !(event.cartData.variant_id === parseInt(this.dataset.index)))
          ) {
            return;
          }
          // If it's another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      get input() {
        return this.querySelector("quantity-input input");
      }

      listenForActiveInput() {
        if (!this.classList.contains("hidden")) {
          this.input?.addEventListener("focusin", (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.input?.addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
            this.input?.blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          "keypress",
          () => {
            event.target.setCustomValidity("");
          },
          { once: true },
        );
      }

      get sectionId() {
        if (!this._sectionId) {
          this._sectionId = this.dataset.sectionId;
        }

        return this._sectionId;
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          const _cartFetch = (window.CartQueue ? window.CartQueue.fetch : fetch);
          _cartFetch(this.getSectionsUrl())
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, "text/html");
              const sourceQty = html.querySelector(
                `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
              );
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsUrl() {
        const pageParams = new URLSearchParams(window.location.search);
        pageParams.set("section_id", this.sectionId);
        return `${window.location.pathname}${pageParams.toString() ? "?" + pageParams.toString() : ""}`;
      }

      updateMultipleQty(items) {
        this.setLoading(true);

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        const _cartFetch = (window.CartQueue ? window.CartQueue.fetch : fetch);
        _cartFetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderSections(parsedState, ids);

            if (this.revealHeader) {
              document.querySelector("sticky-header")?.reveal?.();
            }

            if (this.triggerCart) {
              document.querySelector("mini-cart")?.open?.();
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: "quick-add", cartData: parsedState });
          })
          .catch((error) => {
            console.log(error);
            // Commented out for now and will be fixed when Shopify Backend issue is done
            // e.target.setCustomValidity(error);
            // e.target.reportValidity();
            // this.resetQuantityInput(ids[index]);
            // this.selectProgressBar().classList.add('hidden');
            // e.target.select();
            // this.cleanErrorMessageOnType(e);
          })
          .finally(() => {
            this.setLoading(false);
            this.setRequestStarted(false);
          });
      }

      setLoading(loading = false) {
        const progressBar = this.querySelector(".qty-progress-bar-container");
        const spinner = this.querySelector(".spinner");
        const checkmark = this.querySelector(".quantity-success-check");

        if (loading) {
          progressBar.classList.add("visible");
          spinner.classList.add("visible");
          checkmark.classList.remove("visible");
        } else {
          progressBar.classList.remove("visible");
          spinner.classList.remove("visible");
          checkmark.classList.add("visible");
          setTimeout(() => checkmark.classList.remove("visible"), 1250);
        }
      }

      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
            section: this.sectionId,
            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
          },
          {
            id: "header",
            section: document.getElementById("header")?.dataset.id,
            selector: ".head-slot-cart-link",
          },
          {
            id: "header-mini-cart-content",
            section: "header-mini-cart-content",
          },
          {
            id: "header-mini-cart-footer",
            section: "header-mini-cart-footer",
          },
          {
            id: "mobile-dock",
            section: document.getElementById("mobile-dock")?.dataset.id,
            selector: ".head-slot-cart-link",
          },
        ].filter((section) => {
          const element = document.getElementById(section.id);
          return element && (section.selector ? element.querySelector(section.selector) : true);
        });
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    },
  );
}

document.body.addEventListener("click", (event) => {
  if (!document.body.classList.contains("drawer-open")) {
    return;
  }

  if (event.target.closest(".drawer")) {
    return;
  }

  if (event.target.closest("drawer-toggle")) {
    return;
  }

  // Close all drawers
  [...document.querySelectorAll(".drawer")].forEach((drawer) => {
    const dismiss = drawer.querySelector("drawer-toggle");

    if (dismiss) {
      dismiss.close();
    }
  });
});

// Focus trap
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) {
        currentFocusedElement.classList.remove("focused");
      }

      if (mouseClick) {
        return;
      }

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) {
    elementToFocus.focus();
  }
}

function debounce(func, wait, immediate) {
  let timeout;

  return function executedFunction() {
    const context = this;
    const args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) {
      model.modelViewerUI.pause();
    }
  });
}

(function () {
  // We wrap each RTE table by a specific class to allow wrapping
  document.querySelectorAll(".rte table").forEach(function (table) {
    table.outerHTML = '<div class="table-wrapper">' + table.outerHTML + "</div>";
  });
  document.querySelectorAll(".rte iframe").forEach(function (iframe) {
    // We scope the wrapping only for YouTube and Vimeo
    if (
      iframe.src.indexOf("youtube") !== -1 ||
      iframe.src.indexOf("youtu.be") !== -1 ||
      iframe.src.indexOf("vimeo") !== -1
    ) {
      iframe.outerHTML = '<div class="video-wrapper">' + iframe.outerHTML + "</div>"; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

      iframe.src = iframe.src;
    }
  });
})();

/*
 * Shopify Common JS
 * Source: Dawn theme
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/*
 * Copy to Clipboard Component
 */
class CopyToClipboard extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.originalText = this.button ? this.button.firstChild.textContent.trim() : "";
    this.tooltipText = this.dataset.tooltipText;
    this.copiedText = this.dataset.copiedText;
    this.copiedTimeout = null;
    this.tooltipElement = null;
  }

  connectedCallback() {
    if (!this.button) return;

    this.button.addEventListener("click", this.handleCopy.bind(this));
    this.button.addEventListener("mouseenter", this.showTooltip.bind(this));
    this.button.addEventListener("mouseleave", this.hideTooltip.bind(this));
    this.button.addEventListener("focus", this.showTooltip.bind(this));
    this.button.addEventListener("blur", this.hideTooltip.bind(this));
  }

  disconnectedCallback() {
    if (!this.button) return;

    this.button.removeEventListener("click", this.handleCopy.bind(this));
    this.button.removeEventListener("mouseenter", this.showTooltip.bind(this));
    this.button.removeEventListener("mouseleave", this.hideTooltip.bind(this));
    this.button.removeEventListener("focus", this.showTooltip.bind(this));
    this.button.removeEventListener("blur", this.hideTooltip.bind(this));

    if (this.copiedTimeout) {
      clearTimeout(this.copiedTimeout);
    }
  }

  async handleCopy(event) {
    event.preventDefault();

    try {
      await navigator.clipboard.writeText(this.originalText);
      this.showCopiedState();
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  }

  showCopiedState() {
    if (!this.button) return;

    // Update tooltip to "Copied!"
    this.updateTooltipText(this.copiedText);

    // Add copied class for styling
    this.button.classList.add("is-copied");

    // Clear any existing timeout
    if (this.copiedTimeout) {
      clearTimeout(this.copiedTimeout);
    }

    // Reset after 2 seconds
    this.copiedTimeout = setTimeout(() => {
      this.button.classList.remove("is-copied");
      if (this.tooltipElement) {
        this.updateTooltipText(this.tooltipText);
      }
    }, 2000);
  }

  showTooltip() {
    if (!this.button) return;

    // Don't show tooltip if already exists
    if (this.tooltipElement) return;

    const tooltipText = this.button.classList.contains("is-copied")
      ? this.copiedText
      : this.tooltipText;

    this.tooltipElement = document.createElement("div");
    this.tooltipElement.className = "copy-tooltip";
    this.tooltipElement.textContent = tooltipText;
    this.appendChild(this.tooltipElement);

    // Trigger reflow for animation
    setTimeout(() => {
      this.tooltipElement?.classList.add("is-visible");
    }, 10);
  }

  hideTooltip() {
    if (!this.tooltipElement) return;

    this.tooltipElement.classList.remove("is-visible");

    setTimeout(() => {
      if (this.tooltipElement && this.tooltipElement.parentNode) {
        this.tooltipElement.remove();
        this.tooltipElement = null;
      }
    }, 200);
  }

  updateTooltipText(text) {
    if (this.tooltipElement) {
      this.tooltipElement.textContent = text;
    }
  }
}

customElements.define("copy-to-clipboard", CopyToClipboard);

// ========================================
// SAFE LOCALE GETTER
// ========================================

function getLocaleString(path) {
  if (!window.themeStrings) return null;

  return path.split(".").reduce((obj, key) => {
    if (!obj || typeof obj !== "object") return null;
    return obj[key];
  }, window.themeStrings) || null;
}


// ========================================
// TOAST MANAGER
// ========================================

class ToastManager {
  constructor() {
    this.container = document.getElementById("toast-container");
  }

  show({
    type = "info",
    title = "",
    message = "",
    duration = 4000,
    layout = "multi"
  }) {
    if (!this.container) return;

    const toast = document.createElement("div");
    toast.className = `toast toast--${type} toast--${layout}`;

    toast.innerHTML = `
      <div class="toast__icon">
        ${this.getIcon(type)}
      </div>

      <div class="toast__content">
        ${
          layout === "single"
            ? `<div class="toast__single-line">
                ${title ? `<strong>${title}</strong> ` : ""}
                ${message}
              </div>`
            : `
              ${title ? `<div class="toast__title">${title}</div>` : ""}
              <div class="toast__message">${message}</div>
            `
        }
      </div>

      <button class="toast__close" aria-label="Close">
        ${this.getCloseIcon()}
      </button>
    `;

    this.container.appendChild(toast);

    toast.querySelector(".toast__close").addEventListener("click", () => {
      this.hide(toast);
    });

    if (duration > 0) {
      setTimeout(() => this.hide(toast), duration);
    }
  }

  hide(toast) {
    toast.classList.add("toast--hide");
    setTimeout(() => toast.remove(), 250);
  }

  getIcon(type) {
    const icons = {
      success: `
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" fill="#237659"/>
          <path d="M7 12l3 3 7-7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
      error: `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <rect x="1" y="1" width="14" height="14" rx="7" fill="#E91616"/>
          <path d="M5 5L11 11M11 5L5 11" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
      `,
      warning: `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2.5 13L8 3.5L13.5 13H2.5Z" fill="#F6CC6F"/>
        </svg>
      `,
      info: `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="7" stroke="#4C6DB3" stroke-width="2"/>
          <circle cx="8" cy="5" r="1" fill="#4C6DB3"/>
          <rect x="7.5" y="7" width="1" height="4" fill="#4C6DB3"/>
        </svg>
      `
    };

    return icons[type] || icons.info;
  }

  getCloseIcon() {
    return `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    `;
  }
}

// Initialize Toast
window.toast = new ToastManager();


// ========================================
// TRANSLATED TOAST FUNCTION
// ========================================

function showTranslatedToast(
  key,
  type = "info",
  layout = "multi",
  duration = 4000
) {
  if (!window.toast) return;

  const title = getLocaleString(`toast_notification.${key}.title`);
  const message = getLocaleString(`toast_notification.${key}.message`);
  console.log("Toast Title:", title);
  console.log("Toast Message:", message);
  if (!title) return;  // Only block if title is missing

  window.toast.show({
    type,
    title,
    ...(message && { message }),  // Only include message if it exists
    layout,
    duration
  });
}

/* ================================
   BULK PRICING ENGINE (FULL SYNC)
   - Scope-aware: works on PDP and inside quick-view-drawer
================================ */

let lastActiveBulkTier = null;
let originalPriceStore = {};

/* ================================
   SCOPE HELPER
   Returns the closest container that scopes bulk pricing:
   quick-view-drawer > bulk-drawer > ProductPage > document
================================ */

function getScopeFromElement(el) {
  if (!el) return document;
  return (
    el.closest("quick-view-drawer") ||
    el.closest(".bulk-drawer") ||
    el.closest('[id^="ProductPage-"]') ||
    document
  );
}

/* ================================
   APPLY BUTTON HELPER
================================ */

function toggleApplyButton(scope, enable) {
  const drawer =
    scope.querySelector?.(".bulk-drawer") ||
    (scope.classList?.contains("bulk-drawer") ? scope : null);

  if (!drawer) return;

  const btn = drawer.querySelector(".bulk-apply-btn");
  if (!btn) return;

  btn.disabled = !enable;
  btn.classList.toggle("disabled", !enable);
}

/* ================================
   HELPER: BUILD HTML
================================ */

function buildPriceHTML(priceContainer, priceBox) {
  const unitPricing = priceBox.querySelector(".custom-unit-pricing");

  let html = priceContainer.innerHTML;

  if (unitPricing) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    const wrapper = temp.querySelector(".sale-discount-wrapper");

    if (wrapper) {
      wrapper.insertAdjacentHTML("afterend", unitPricing.outerHTML);
    } else {
      temp.innerHTML += unitPricing.outerHTML;
    }

    html = temp.innerHTML;
  }

  return html;
}

/* ================================
   UPDATE STICKY (PDP only)
================================ */

function updateSticky(priceContainer, priceBox) {
  const scontainer = document.querySelector(
    ".sticky-addtocart-panel-left-right-price"
  );
  if (!scontainer) return;

  const stickyPriceBox = scontainer.querySelector(".price");
  if (!stickyPriceBox) return;

  if (priceBox.classList.contains("price-on-sale")) {
    stickyPriceBox.classList.add("price-on-sale");
  } else {
    stickyPriceBox.classList.remove("price-on-sale");
  }

  let stickyPriceContainer = stickyPriceBox.querySelector(".price-container");
  if (!stickyPriceContainer) {
    stickyPriceContainer = document.createElement("div");
    stickyPriceContainer.className = "price-container";
    stickyPriceBox.prepend(stickyPriceContainer);
  }

  stickyPriceContainer.innerHTML = priceContainer.innerHTML;

  const mainUnitPricing = priceBox.querySelector(".custom-unit-pricing");
  let stickyUnitPricing = stickyPriceBox.querySelector(
    ":scope > .custom-unit-pricing"
  );

  if (mainUnitPricing) {
    if (stickyUnitPricing) {
      stickyUnitPricing.innerHTML = mainUnitPricing.innerHTML;
    } else {
      stickyPriceBox.appendChild(mainUnitPricing.cloneNode(true));
    }
  } else if (stickyUnitPricing) {
    stickyUnitPricing.remove();
  }
}

/* ================================
   UPDATE DRAWER PRICE (scoped)
================================ */

function updateDrawerPrice(scope, sectionId, priceContainer, priceBox) {
  // Look inside scope first; fall back to document
  const drawer =
    (scope !== document &&
      scope.querySelector?.(`#BulkDrawer-${sectionId}`)) ||
    document.querySelector(`#BulkDrawer-${sectionId}`);

  if (!drawer) return;

  const drawerPrice = drawer.querySelector(`#BulkDrawerPrice-${sectionId}`);
  if (!drawerPrice) return;

  drawerPrice.innerHTML = buildPriceHTML(priceContainer, priceBox);
}

/* ================================
   UPDATE BULK PRICE (scope-aware)
================================ */

function updateBulkPrice(form) {
  if (!form) return;

  const qtyInput = form.querySelector(".quantity-input-field");
  const qty = parseInt(qtyInput?.value, 10);
  if (!qty || qty < 1) return;

  const sectionId = form.querySelector('[name="section-id"]')?.value;
  if (!sectionId) return;

  // Determine scope: quick-view-drawer or PDP
  const quickView = form.closest("quick-view-drawer");
  const scope =
    quickView ||
    form.closest(`#ProductPage-${sectionId}`) ||
    document.querySelector(`#ProductPage-${sectionId}`) ||
    document;

  if (!scope) return;

  // Find price box within scope (PDP: inside #price-x; Quick view: inside drawer-footer .product-block-price)
  let priceBox =
    scope.querySelector?.(`#price-${sectionId} .price`) ||
    scope.querySelector?.(".drawer-footer .product-block-price .price") ||
    scope.querySelector?.(".product-block-price .price");

  if (!priceBox) return;

  const priceContainer = priceBox.querySelector(".price-container");
  if (!priceContainer) return;

  /* GET BASE PRICE */

  let basePrice = null;
  let compareAt = null;

  const selectedOption = scope.querySelector?.(
    "variant-selects select option:checked"
  );

  if (selectedOption) {
    const variantScript = scope.querySelector(
      `script[data-resource="${selectedOption.id}"]`
    );

    if (variantScript) {
      try {
        const variant = JSON.parse(variantScript.textContent);
        basePrice = variant.price / 100;
        compareAt = variant.compare_at_price
          ? variant.compare_at_price / 100
          : null;
      } catch (err) {
        console.warn("Failed to parse variant JSON", err);
      }
    }
  }

  // Cache key needs to differ for PDP vs quick view so they don't share state
  const cacheKey = quickView ? `qv-${sectionId}` : sectionId;

  if (basePrice === null) {
    if (!originalPriceStore[cacheKey]) {
      const priceEl =
        priceBox.querySelector(".price-item-regular") ||
        priceBox.querySelector(".price-item-sale");

      if (!priceEl) return;

      const raw = priceEl.textContent
        .replace(",", ".")
        .replace(/[^\d.]/g, "");

      basePrice = parseFloat(raw);
      if (isNaN(basePrice)) return;

      originalPriceStore[cacheKey] = basePrice;
    } else {
      basePrice = originalPriceStore[cacheKey];
    }

    compareAt = null;
  }

  if (basePrice === null) return;

  /* FIND ACTIVE BULK TIER — SCOPED */

  let activeTier = null;

  scope.querySelectorAll(".bulk-tier-radio").forEach((radio) => {
    const minQty = parseInt(radio.dataset.minQty, 10);

    if (
      qty >= minQty &&
      (!activeTier ||
        minQty > parseInt(activeTier.dataset.minQty, 10))
    ) {
      activeTier = radio;
    }
  });

  /* NO TIER */

  if (!activeTier) {
    renderOriginalPrice(scope, priceBox, basePrice, compareAt, sectionId);
    lastActiveBulkTier = null;
    toggleApplyButton(scope, false);
    return;
  }

  /* APPLY BULK PRICE */

  const tierPrice = parseFloat(activeTier.dataset.price);

  const multiplier = parseFloat(activeTier.dataset.vatMultiplier || "1");
  const displayTierPrice = tierPrice * multiplier;

  const referencePrice = (compareAt && compareAt > basePrice ? compareAt : basePrice);
  const discount = Math.round(
    ((referencePrice - displayTierPrice) / referencePrice) * 100
  );

  priceBox.classList.add("price-on-sale");
  toggleApplyButton(scope, true);

  priceContainer.innerHTML = `
    <div class="price-sale">
      <span class="price-item price-item-sale price-item-last">
        € ${((displayTierPrice * 100) / 100).toFixed(2).replace(".", ",")}
      </span>
      <div class="sale-discount-wrapper">
        <s class="price-item price-item-regular">
          € ${((referencePrice * 100) / 100).toFixed(2).replace(".", ",")}
        </s>
        <span class="badge badge-sale">
          -${discount}%
        </span>
      </div>
    </div>
  `;

  // Only update sticky if PDP context (not quick view)
  if (!quickView) {
    updateSticky(priceContainer, priceBox);
  }

  updateDrawerPrice(scope, sectionId, priceContainer, priceBox);

  const tierId = activeTier.dataset.minQty;

  if (lastActiveBulkTier !== tierId) {
    lastActiveBulkTier = tierId;

    if (typeof showTranslatedToast === "function") {
      showTranslatedToast("bulk_success", "success", "single", 3500);
    }
  }
}

/* ================================
   RESTORE ORIGINAL PRICE (scope-aware)
================================ */

function renderOriginalPrice(scope, container, price, compareAt, sectionId) {
  container.classList.remove("price-on-sale");

  const priceContainer = container.querySelector(".price-container");
  if (!priceContainer) return;

  if (compareAt && compareAt > price) {
    const discount = Math.round(((compareAt - price) / compareAt) * 100);

    container.classList.add("price-on-sale");

    priceContainer.innerHTML = `
      <div class="price-sale">
        <span class="price-item price-item-sale price-item-last">
          € ${(Math.floor(price * 100) / 100).toFixed(2).replace(".", ",")}
        </span>
        <div class="sale-discount-wrapper">
          <s class="price-item price-item-regular">
            € ${(Math.floor(compareAt * 100) / 100).toFixed(2).replace(".", ",")}
          </s>
          <span class="badge badge-sale">
            -${discount}%
          </span>
        </div>
      </div>
    `;
  } else {
    priceContainer.innerHTML = `
      <div class="price-regular">
        <span class="price-item price-item-regular">
          € ${(Math.floor(price * 100) / 100).toFixed(2).replace(".", ",")}
        </span>
      </div>
    `;
  }

  // Only update sticky if PDP context
  const isQuickView = scope && scope.tagName === "QUICK-VIEW-DRAWER";
  if (!isQuickView) {
    updateSticky(priceContainer, container);
  }

  if (sectionId) {
    updateDrawerPrice(scope, sectionId, priceContainer, container);
  }
}

/* ================================
   SYNC RADIO WITH QTY (scoped)
================================ */

function syncBulkTier(qty, scope) {
  scope = scope || document;
  let best = null;

  scope.querySelectorAll(".bulk-tier-radio").forEach((r) => {
    const min = parseInt(r.dataset.minQty, 10);

    if (qty >= min && (!best || min > parseInt(best.dataset.minQty))) {
      best = r;
    }

    r.checked = false;
  });

  if (best) {
    scope
      .querySelectorAll(
        `.bulk-tier-radio[data-min-qty="${best.dataset.minQty}"]`
      )
      .forEach((r) => (r.checked = true));
  }
}

/* ================================
   BULK PROGRESS MESSAGE (scoped)
================================ */

function updateBulkProgress(qty, scope) {
  scope = scope || document;

  scope.querySelectorAll(".bulk-progress-wrapper").forEach((wrapper) => {
    const qtyEl = wrapper.querySelector(".bulk-qty");
    const percentEl = wrapper.querySelector(".bulk-percentage");

    if (!qty || !qtyEl || !percentEl || qty <= 1) {
      wrapper.style.display = "none";
      return;
    }

    const radios = [...scope.querySelectorAll(".bulk-tier-radio")];

    const tiers = radios
      .map((radio) => {
        const minQty = parseInt(radio.dataset.minQty, 10);

        const discountBadge = radio
          .closest(".bulk-tier")
          ?.querySelector(".bulk-discount");

        let discount = 0;

        if (discountBadge) {
          const match = discountBadge.textContent.match(/(\d+)%/);
          if (match) discount = parseInt(match[1], 10);
        }

        return { minQty, discount };
      })
      .filter((t) => !isNaN(t.minQty) && t.discount > 0)
      .sort((a, b) => a.minQty - b.minQty);

    if (!tiers.length) return (wrapper.style.display = "none");

    const highest = tiers[tiers.length - 1];
    if (qty >= highest.minQty) return (wrapper.style.display = "none");

    const nextTier = tiers.find((t) => qty < t.minQty);
    if (!nextTier) return (wrapper.style.display = "none");

    qtyEl.textContent = nextTier.minQty - qty;
    percentEl.textContent = nextTier.discount + "%";

    wrapper.style.display = "block";
  });
}

/* ================================
   MASTER SYNC FUNCTION (scope-aware)
================================ */

function handleQtyChange(input) {
  const qty = parseInt(input.value, 10);
  if (!qty || qty < 1) return;

  // Determine scope
  const quickView = input.closest("quick-view-drawer");
  const bulkDrawer = input.closest(".bulk-drawer");
  const productPage = input.closest('[id^="ProductPage-"]');

  if (!quickView && !bulkDrawer && !productPage) return;

  // Determine sectionId
  let sectionId;
  if (quickView) {
    sectionId =
      quickView.querySelector('[name="section-id"]')?.value ||
      "quickview-drawer";
  } else if (bulkDrawer) {
    sectionId = bulkDrawer.id.replace("BulkDrawer-", "");
  } else {
    sectionId = productPage.id.replace("ProductPage-", "");
  }

  // Operative scope (the container we look inside)
  const scope = quickView || document;

  // Sync all qty inputs within scope (PDP, BulkDrawer, drawer-footer)
  const inputs = scope.querySelectorAll(`
    #ProductPage-${sectionId} .quantity-input-field,
    #BulkDrawer-${sectionId} .quantity-input-field,
    .drawer-footer .quantity-input-field,
    .product-block-product-form .quantity-input-field
  `);

  inputs.forEach((el) => {
    if (el !== input) el.value = qty;
  });

  // Sync radios within scope
  syncBulkTier(qty, scope);

  // Update progress within scope
  updateBulkProgress(qty, scope);

  // Update forms within scope
  const forms = scope.querySelectorAll(`
    #ProductPage-${sectionId} product-form,
    #BulkDrawer-${sectionId} product-form,
    .drawer-footer product-form,
    .product-block-product-form product-form
  `);

  forms.forEach((form) => {
    updateBulkPrice(form);
  });
}

/* ================================
   LISTENERS
================================ */

document.addEventListener("input", (e) => {
  if (e.target.classList.contains("quantity-input-field")) {
    handleQtyChange(e.target);
  }
});

/* RADIO LISTENER (scope-aware) */

document.addEventListener("change", (e) => {
  const radio = e.target.closest(".bulk-tier-radio");
  if (!radio) return;

  const drawer = radio.closest(".bulk-drawer");
  if (drawer) {
    const btn = drawer.querySelector(".bulk-apply-btn");
    if (btn) {
      btn.disabled = false;
      btn.classList.remove("disabled");
    }
  }

  const qty = parseInt(radio.dataset.minQty, 10);
  if (!qty) return;

  // Determine scope of this radio (quick view OR document)
  const scope = radio.closest("quick-view-drawer") || document;

  // Set all qty inputs within scope to this qty
  scope.querySelectorAll(".quantity-input-field").forEach((input) => {
    input.value = qty;
  });

  // Trigger handleQtyChange on the FIRST qty input within scope
  const firstInput = scope.querySelector(".quantity-input-field");
  if (firstInput) {
    handleQtyChange(firstInput);
  }
});

/* +/- BUTTONS */

document.addEventListener("click", function (e) {
  const plus = e.target.closest(".quantity-input-plus");
  const minus = e.target.closest(".quantity-input-minus");

  if (!plus && !minus) return;

  const wrapper = e.target.closest(".quantity-input");
  if (!wrapper) return;

  const input = wrapper.querySelector(".quantity-input-field");
  if (!input) return;

  const isBulkContext =
    wrapper.closest(".bulk-drawer") ||
    wrapper.closest('[id^="ProductPage-"]') ||
    wrapper.closest("quick-view-drawer");

  if (!isBulkContext) return;

  setTimeout(() => {
    handleQtyChange(input);
  }, 50);
});

/* VARIANT CHANGE — reset */

document.addEventListener("product:variant-change", (e) => {
  lastActiveBulkTier = null;

  // Reset within the scope where the variant change happened (if available)
  const scope =
    (e.target && getScopeFromElement(e.target)) || document;

  scope.querySelectorAll(".quantity-input-field").forEach((input) => {
    input.value = 1;
  });

  scope.querySelectorAll(".bulk-apply-btn").forEach((btn) => {
    btn.disabled = true;
    btn.classList.add("disabled");
  });
});

let lastFocusedElement = null;
let focusTrapHandler = null;

document.addEventListener('click', function (e) {

  /* ================= OPEN ================= */
  const openBtn = e.target.closest('[data-bulk-open]');
  if (openBtn) {
    const sectionId = openBtn.getAttribute('data-bulk-open');

    const drawer = document.getElementById('BulkDrawer-' + sectionId);
    const overlay = document.getElementById('BulkOverlay-' + sectionId);

    if (!drawer || !overlay) return;

    lastFocusedElement = openBtn;

    drawer.classList.add('is-open');
    overlay.classList.add('is-open');

    updateApplyButtonState(drawer);

    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');

    document.body.classList.add('bulk-drawer-open');

    // Move focus to drawer
    setTimeout(() => {
      drawer.focus();
      trapFocus(drawer);
    }, 50);
  }

  /* ================= CLOSE BUTTON ================= */
  const closeBtn = e.target.closest('[data-bulk-close]');
  if (closeBtn) {
    const sectionId = closeBtn.getAttribute('data-bulk-close');
    closeDrawer(sectionId);
  }

  /* ================= BACK BUTTON ================= */
  const backBtn = e.target.closest('.bulk-drawer-back');
  if (backBtn) {

    const drawer = backBtn.closest('.bulk-drawer');
    if (!drawer) return;

    const sectionId = drawer.id.replace('BulkDrawer-', '');

    closeDrawer(sectionId);
  }

  /* ================= OVERLAY CLICK ================= */
  const overlayClick = e.target.closest('.bulk-overlay');
  if (overlayClick) {
    const sectionId = overlayClick.id.replace('BulkOverlay-', '');
    closeDrawer(sectionId);
  }

  /* ================= APPLY BUTTON CLICK ================= */
  const applyBtn = e.target.closest('.bulk-apply-btn');
  if (applyBtn) {

    // Do nothing if disabled
    if (applyBtn.hasAttribute('disabled')) return;

    const drawer = applyBtn.closest('.bulk-drawer');
    if (!drawer) return;

    const sectionId = drawer.id.replace('BulkDrawer-', '');
    closeDrawer(sectionId);
  }

});


/* ================= CLOSE FUNCTION ================= */

function closeDrawer(sectionId) {

  const drawer = document.getElementById('BulkDrawer-' + sectionId);
  const overlay = document.getElementById('BulkOverlay-' + sectionId);

  if (!drawer || !overlay) return;

  drawer.classList.remove('is-open');
  overlay.classList.remove('is-open');

  drawer.setAttribute('aria-hidden', 'true');
  overlay.setAttribute('aria-hidden', 'true');

  document.body.classList.remove('bulk-drawer-open');

  releaseFocusTrap();

  if (lastFocusedElement) {
    lastFocusedElement.focus();
  }
}


/* ================= ESC KEY CLOSE ================= */

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    const openDrawer = document.querySelector('.bulk-drawer.is-open');
    if (!openDrawer) return;

    const sectionId = openDrawer.id.replace('BulkDrawer-', '');
    closeDrawer(sectionId);
  }
});


/* ================= FOCUS TRAP ================= */

function trapFocus(container) {

  const focusableSelectors =
    'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])';

  const focusableElements = container.querySelectorAll(focusableSelectors);
  if (!focusableElements.length) return;

  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];

  focusTrapHandler = function (e) {

    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  document.addEventListener('keydown', focusTrapHandler);
}

function releaseFocusTrap() {
  if (focusTrapHandler) {
    document.removeEventListener('keydown', focusTrapHandler);
    focusTrapHandler = null;
  }
}

document.addEventListener("blur", function (e) {
  const input = e.target.closest(".quantity-input-field");
  if (!input) return;
  let value = parseInt(input.value, 10);
  if (isNaN(value) || value < 1) {
    input.value = 1;
  }
}, true);

// ========================================
// PALLET MANAGER (corrected)
// ========================================
//
// Business rules (per the tree diagram):
//   1. Delivery type != BM           -> no pallet
//   2. Delivery type == BM:
//      a. Only PalletItem=N lines    -> 1 standard pallet
//      b. Only PalletItem=Y lines    -> for EACH Y line item independently:
//            - if qty < MinimumAantalPallet            -> 0 pallets for this line
//            - else 1 base pallet + extras when qty
//              reaches (MinimumAantalPallet + AantalOpPallet),
//              then +1 for every additional AantalOpPallet
//         Sum the pallets across all Y line items.
//         (If the sum is 0 because no Y line met its threshold, still
//          add 1 pallet — the order is BM so it needs at least one.)
//      c. Combined N + Y             -> 1 standard pallet for the N items,
//         PLUS for each Y line item that meets its own min threshold:
//         add 1 base pallet + extras when qty reaches
//         (MinimumAantalPallet + AantalOpPallet), then +1 for every
//         further AantalOpPallet (same per-line formula as Only-Y).
//         If NO Y line meets its min, only the standard N pallet is added.
//
// Key fix vs the previous version:
//   * Pallets are now calculated PER LINE ITEM using THAT line's own
//     _unitpp (MinimumAantalPallet) and _extracapacity (AantalOpPallet),
//     instead of pooling all Y-quantities and reading thresholds from
//     whichever item came first.

const PalletManager = (() => {
  let _running = null;        // settle-promise of the active run (+ drained re-runs), or null
  let _rerunQueued = false;   // a follow-up run was requested while one was active
  let _rerunAttrs = null;     // deliveryAttrs for that queued run
  let _pendingDeliveryAttrs = null; // delivery attrs deferred when pure-add (no removals)

  const toInt = value => {
    const n = parseInt(value, 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
  };

  /**
   * Extra pallets BEYOND the first one, for a single Y line item.
   * qty < min                -> 0  (line doesn't even reach the threshold)
   * min <= qty < min+cap     -> 0  (covered by the base pallet)
   * qty >= min+cap           -> 1 + floor((qty - (min+cap)) / cap)
   */
  function extraPalletsForLine(qty, min, cap) {
    if (min <= 0 || cap <= 0 || qty <= 0) return 0;
    const firstExtraThreshold = min + cap;
    if (qty < firstExtraThreshold) return 0;
    return 1 + Math.floor((qty - firstExtraThreshold) / cap);
  }

  /**
   * Total pallets for a single Y line item when it stands alone
   * (Only-Y branch). Returns 0 if qty doesn't meet min.
   */
  function palletsForYLine(qty, min, cap) {
    if (min <= 0 || cap <= 0 || qty <= 0) return 0;
    if (qty < min) return 0;
    return 1 + extraPalletsForLine(qty, min, cap);
  }

  // Public entry point. Serializes AND coalesces: while a run is in flight, a new
  // request no longer drops its work (the old guard silently lost pallet updates
  // when two syncs collided) — it queues exactly one follow-up run and returns the
  // same settle-promise, so every caller awaits the true final state and
  // re-renders correctly.
  function sync(deliveryAttrs) {
    if (_running) {
      _rerunQueued = true;
      if (deliveryAttrs) _rerunAttrs = deliveryAttrs;
      console.log("[PalletManager] sync() queued — will re-run after current");
      return _running;
    }
    _running = _runAndDrain(deliveryAttrs).finally(() => { _running = null; });
    return _running;
  }

  // Run once, then drain any request(s) that arrived during the run so the cart
  // always converges to the latest state. Returns whether ANY run changed items.
  async function _runAndDrain(deliveryAttrs) {
    let changed = await _syncOnce(deliveryAttrs);
    while (_rerunQueued) {
      _rerunQueued = false;
      const attrs = _rerunAttrs;
      _rerunAttrs = null;
      changed = (await _syncOnce(attrs)) || changed;
    }
    return changed;
  }

  async function _syncOnce(deliveryAttrs) {
    // Always reset so getPendingDeliveryAttrs() never returns stale data.
    _pendingDeliveryAttrs = null;

    console.log("[PalletManager] sync() started");

    try {
      const cart = await window.CartStore.get();

      if (!cart?.items) {
        console.warn("[PalletManager] No cart or cart items found — aborting");
        return false;
      }

      const selectedRadio = document.querySelector(
        'input[name="delivery_option"]:checked'
      );
      const deliveryMethod =
        selectedRadio?.value || cart.attributes?.["delivery-method"];

      // ------------------------------------------------------------------
      // No delivery method selected yet: do nothing.
      // We must NOT add a pallet line before the customer has chosen a
      // delivery option, otherwise updating any BM product will inject
      // a pallet item even though shipping/pickup hasn't been decided.
      // ------------------------------------------------------------------
      if (!deliveryMethod) {
        console.log("[PalletManager] No delivery method selected — skipping sync");
        return false;
      }

      // ------------------------------------------------------------------
      // Store pickup: remove both pallet and surcharge lines and stop.
      // ------------------------------------------------------------------
      if (deliveryMethod === "Store-Pickup") {
        const palletItem = cart.items.find(
          item => item.properties?._isglobalpallet === "true"
        );
        const surchargeItem = cart.items.find(
          item => item.properties?._isglobalsurcharge === "true"
        );

        // Combine pallet + surcharge removal into ONE /cart/update.js call
        // (line-key → 0). A single request replaces the previous two parallel
        // /cart/change.js POSTs that triggered 429s. CartAPI.update routes
        // through CartQueue and caches the full updated cart.
        const removeUpdates = {};
        if (palletItem)    removeUpdates[palletItem.key]    = 0;
        if (surchargeItem) removeUpdates[surchargeItem.key] = 0;

        if (Object.keys(removeUpdates).length > 0) {
          await CartAPI.update({ updates: removeUpdates });
          return true;
        }
        return false;
      }

      // ------------------------------------------------------------------
      // Collect cart info — pallet + surcharge in one pass.
      // ------------------------------------------------------------------
      let palletLineKey = null;
      let palletLineQty = 0;
      let palletVariantId = null;

      let surchargeLineKey = null;
      let surchargeLineQty = 0;
      let surchargeVariantId = null;
      let hasLargeGoodsBMItem = false;

      const bmPalletYesLines = [];
      let hasBMItem = false;
      let hasBMPalletNoItem = false;

      cart.items.forEach(item => {
        let props = item.properties || {};

        // The global pallet line (the line we manage).
        if (props._isglobalpallet === "true") {
          palletLineKey = item.key;
          palletLineQty = item.quantity;
          return;
        }

        // Managed surcharge line
        if (props._isglobalsurcharge === "true") {
          surchargeLineKey = item.key;
          surchargeLineQty = item.quantity;
          return;
        }

        // Self-heal: lines added OUTSIDE the product form (account savelist /
        // Hydrogen storefront) carry no pallet line-item properties, so sync()
        // would treat them as non-pallet products. Fall back to the variant's
        // pallet metafields, rendered per cart line by Liquid on the cart page
        // (window.BM_PALLET_META, keyed by variant id).
        if (!props._pallettype && window.BM_PALLET_META) {
          const meta = window.BM_PALLET_META[item.variant_id];
          if (meta && meta.pallettype) {
            props = Object.assign({}, props, {
              _pallettype:    meta.pallettype,
              _ispallet:      meta.ispallet,
              _unitpp:        meta.unitpp,
              _extracapacity: meta.extracapacity,
            });
          }
        }

        // Pick up variant IDs from whichever product carries them
        if (!palletVariantId && props._palletvariantID) {
          palletVariantId = props._palletvariantID;
        }
        // console.log("props: ",props);
        if (!surchargeVariantId && props._surchargeVariantID) {
          surchargeVariantId = props._surchargeVariantID;
        }

        // Surcharge: large goods with BM delivery
        if (props._surchargeType === "BM" && props._islargegoods === "true") {
          hasLargeGoodsBMItem = true;
        }

        // Pallet: only BM-delivery products participate
        if (props._pallettype !== "BM") return;

        hasBMItem = true;

        if (props._ispallet === "true") {
          bmPalletYesLines.push({
            qty: item.quantity,
            min: toInt(props._unitpp),         // MinimumAantalPallet for THIS line
            cap: toInt(props._extracapacity)   // AantalOpPallet for THIS line
          });
        } else if (props._ispallet === "false") {
          hasBMPalletNoItem = true;
        }
      });

      const hasBMPalletYesItem = bmPalletYesLines.length > 0;

      // Self-heal (continued): the global pallet/surcharge variant IDs live only
      // on form-added lines (properties[_palletvariantID]/[_surchargeVariantID]).
      // A savelist/Hydrogen cart has none, so fall back to the shop-level config
      // rendered on the cart page — otherwise the pallet/surcharge add below is
      // skipped (it requires a variant id).
      if (window.BM_PALLET_GLOBALS) {
        if (!palletVariantId)    palletVariantId    = window.BM_PALLET_GLOBALS.palletVariantId    || palletVariantId;
        if (!surchargeVariantId) surchargeVariantId = window.BM_PALLET_GLOBALS.surchargeVariantId || surchargeVariantId;
      }

      // ------------------------------------------------------------------
      // Apply the rules.
      // ------------------------------------------------------------------
      let palletsNeeded = 0;

      if (!hasBMItem) {
        // No BM items at all -> no pallet.
        palletsNeeded = 0;
      } else if (hasBMPalletNoItem && !hasBMPalletYesItem) {
        // Only N -> 1 standard pallet.
        palletsNeeded = 1;
      } else if (hasBMPalletYesItem && !hasBMPalletNoItem) {
        // Only Y -> per line item, calculate independently and sum.
        let sum = 0;
        for (const line of bmPalletYesLines) {
          sum += palletsForYLine(line.qty, line.min, line.cap);
        }
        // Safety net: BM order with Y items but none meeting their min
        // still needs the order itself to ship on at least 1 pallet.
        palletsNeeded = sum > 0 ? sum : 1;
      } else {
        // Combined N + Y:
        //   - 1 standard pallet for the N items.
        //   - For each Y line that meets its OWN min threshold, add the
        //     full per-line pallet count (1 base + extras), same formula
        //     as the Only-Y branch. This matches the diagram:
        //     "Calculate number of pallets per line item based on
        //      AantalOpPallet for PalletItem Y".
        //   - If NO Y line meets its min, only the standard pallet is
        //     added (red box in the diagram: "Do not add extra pallet(s)
        //     in addition to the standard pallet for PalletItem N").
        palletsNeeded = 1;
        for (const line of bmPalletYesLines) {
          if (line.min > 0 && line.cap > 0 && line.qty >= line.min) {
            palletsNeeded += palletsForYLine(line.qty, line.min, line.cap);
          }
        }
      }

      // ------------------------------------------------------------------
      // Calculate surcharge needed (flat 1 if any large-good BM item)
      // ------------------------------------------------------------------
      const fuelSurchargeEnabled = window.enableFuelSurcharge === true || window.enableFuelSurcharge === "true";
      const surchargeNeeded = (fuelSurchargeEnabled && palletsNeeded > 0) ? 1 : 0;

      console.log(
        "[PalletManager] palletsNeeded=" + palletsNeeded,
        "surchargeNeeded=" + surchargeNeeded,
        "bmPalletYesLines=" + JSON.stringify(bmPalletYesLines),
        "hasBMPalletNoItem=" + hasBMPalletNoItem,
        "hasLargeGoodsBMItem=" + hasLargeGoodsBMItem
      );

      const updates = {};
      const itemsToAdd = [];

      // When the cart:item-add handler (main-cart-items.liquid) is concurrently
      // adding pallet/surcharge, skip adds here. Both paths would call CartAPI.add
      // with the same variant IDs; CartQueue runs them back-to-back and Shopify
      // merges the quantities → surcharge doubles to 2. Removals are never skipped
      // (they come from delivery-switch, not from the add race).
      const _itemAddInProgress = window._bmPalletAddInProgress === true;

      /* ---- PALLET ---- */
      if (!palletLineKey) {
        if (!_itemAddInProgress && palletsNeeded > 0 && palletVariantId) {
          itemsToAdd.push({ id: palletVariantId, quantity: palletsNeeded, properties: { _isglobalpallet: "true" } });
        }
      } else if (palletsNeeded === 0 || palletLineQty !== palletsNeeded) {
        updates[palletLineKey] = palletsNeeded; // 0 = remove, N = update qty
      }

      /* ---- SURCHARGE ---- */
      if (!surchargeLineKey) {
        if (!_itemAddInProgress && surchargeNeeded > 0 && surchargeVariantId) {
          itemsToAdd.push({ id: surchargeVariantId, quantity: surchargeNeeded, properties: { _isglobalsurcharge: "true" } });
        }
      } else if (surchargeNeeded === 0) {
        updates[surchargeLineKey] = 0;
      } else if (surchargeLineQty !== 1) {
        // Surcharge exists but at wrong qty (e.g. doubled to 2 by a race condition).
        // Always enforce qty=1 — surcharge applies exactly once per cart.
        updates[surchargeLineKey] = 1;
      }

      const hasUpdates       = Object.keys(updates).length > 0;
      const hasAdds          = itemsToAdd.length > 0;
      const hasDeliveryAttrs = !!deliveryAttrs && Object.keys(deliveryAttrs).length > 0;

      if (!hasUpdates && !hasAdds && !hasDeliveryAttrs) {
        console.log("[PalletManager] No cart changes needed");
        return false;
      }

      // Writing delivery attrs THEN immediately adding items creates a 3-request
      // burst: POST update → shop_events_listener GET → POST add → 429.
      // Fix: skip the delivery-attr write when the only work is adding items
      // (no removals). The caller will find them via getPendingDeliveryAttrs()
      // and queue them in _pendingAttributeWrites so finishDeliverySwitchIfReady()
      // flushes them (with shipping_charge) in ONE call after sections re-render.
      const writeAttrsNow = hasDeliveryAttrs && !(hasAdds && !hasUpdates);

      // Step 1: ONE /cart/update.js — pallet/surcharge removals + delivery attrs
      // (delivery attrs only included when writeAttrsNow, i.e. there are removals).
      if (hasUpdates || writeAttrsNow) {
        const body = {};
        if (hasUpdates)     body.updates    = updates;
        if (writeAttrsNow)  body.attributes = deliveryAttrs;
        await CartAPI.update(body);
      }

      // Step 2: ONE /cart/add.js — pallet + surcharge in a single { items: [...] } call.
      // CartAPI.add() invalidates CartStore so fetchCart() GETs fresh post-add data.
      if (hasAdds) {
        await CartAPI.add(itemsToAdd);
      }

      // Stash any unwritten delivery attrs for the caller to pick up.
      if (hasDeliveryAttrs && !writeAttrsNow) {
        _pendingDeliveryAttrs = deliveryAttrs;
      }

      // Return true only when cart ITEMS changed — a delivery-attr-only write does
      // not need a section re-render, so the caller skips it when this is false.
      return hasUpdates || hasAdds;
    } catch (err) {
      console.error("[PalletManager] Error during sync:", err);
      return false;
    } finally {
      console.log("[PalletManager] sync() complete");
    }
  }

  return { sync, getPendingDeliveryAttrs: () => _pendingDeliveryAttrs };
})();

let resizeTimer;

function disableAnimation() {
  document.documentElement.classList.add("no-animation");
  document.documentElement.classList.remove("js-animation-ready");
}

function enableAnimation() {
  document.documentElement.classList.remove("no-animation");
  document.documentElement.classList.add("js-animation-ready");
}

/* On load */
window.addEventListener("load", () => {
  enableAnimation();
});

/* On resize */
window.addEventListener("resize", () => {
  disableAnimation();

  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    enableAnimation();
  }, 250);
});

// ============================================================================
// GLOBAL PAGE LOADER
// HTML lives in theme.liquid (#cart-page-loader + CSS).
// These two functions are the only API the rest of the codebase needs.
//
// Usage from anywhere (any section, any JS file):
//   window.showPageLoader();   // show the full-page overlay
//   window.hidePageLoader();   // hide it
//
// The 8-second auto-hide is a safety net so the overlay never gets stuck
// if a caller forgets to call hidePageLoader() (e.g. unhandled rejection).
// ============================================================================

(function () {
  var _loaderHideTimeout = null;
  var _loaderRefCount = 0;

  function forceHidePageLoader() {
    _loaderRefCount = 0;
    window.hidePageLoader();
  }

  /**
   * Show the full-page loading overlay.
   * Ref-counted — loader stays visible until every showPageLoader()
   * call has been matched by a corresponding hidePageLoader() call.
   */
  window.showPageLoader = function showPageLoader() {
    var loader = document.getElementById('cart-page-loader');
    if (!loader) return;
    clearTimeout(_loaderHideTimeout);
    _loaderRefCount++;
    loader.classList.add('is-visible');
    loader.removeAttribute('aria-hidden');
    // Auto-hide after 8 s as a safety net (resets ref count)
    _loaderHideTimeout = setTimeout(forceHidePageLoader, 8000);
  };

  /**
   * Hide the full-page loading overlay.
   * Only truly hides when all showPageLoader() callers have released.
   * Safe to call even if the overlay is already hidden.
   */
  window.hidePageLoader = function hidePageLoader() {
    var loader = document.getElementById('cart-page-loader');
    if (!loader) return;
    _loaderRefCount = Math.max(0, _loaderRefCount - 1);
    if (_loaderRefCount > 0) return;
    clearTimeout(_loaderHideTimeout);
    loader.classList.remove('is-visible');
    loader.setAttribute('aria-hidden', 'true');
  };
})();

// ============================================================================
// End GLOBAL PAGE LOADER
// ============================================================================

// ============================================================================
// JOB STEPPER (roadmap navigation)
// ----------------------------------------------------------------------------
// Shared by the taskpage / article-service-overview / page-static /
// category-details sections, which all render the same #JobStepperWrapper
// markup. Runs only on pages where that wrapper exists, so it is a no-op
// everywhere else. Handles: the sticky top offset (header + pinned banner),
// the active-step-on-scroll indicator (progress bar and/or step lines —
// whichever the page renders), and the mobile dropdown.
// ============================================================================
(function () {
  function initJobStepper() {
    var stepperWrapper = document.getElementById('JobStepperWrapper');
    if (!stepperWrapper) return; // page has no stepper — nothing to do

    var stepperLinks = document.querySelectorAll('.job-step__link');
    var roadmap = document.querySelector('[id$="-roadmap-view"]');
    var sections = roadmap
      ? roadmap.querySelectorAll('.job-section')
      : document.querySelectorAll('.job-section');
    var header = document.querySelector('.header') || document.querySelector('header');
    var banner = document.getElementById('pdp-header-banner');

    // --- Sticky top: header height, plus the PDP banner while it is pinned ---
    // The banner counts only while it's sticky and not dismissed (.hidden);
    // the observer re-runs this so closing the banner removes the leftover gap.
    function updateStepperTop() {
      var headerHeight = header ? header.offsetHeight : 0;
      var bannerHeight = (banner
        && banner.classList.contains('pdp-header-banner--sticky')
        && !banner.classList.contains('hidden')
        && banner.offsetParent !== null) ? banner.offsetHeight : 0;
      var stickyTop = headerHeight + bannerHeight;

      if (stickyTop > 0) {
        stepperWrapper.style.top = stickyTop + 'px';
      }
      if (stepperLinks.length && sections.length) {
        var totalOffset = stickyTop + stepperWrapper.offsetHeight + 20;
        sections.forEach(function (section) {
          section.style.scrollMarginTop = totalOffset + 'px';
        });
      }
    }

    updateStepperTop();

    if (banner) {
      new MutationObserver(updateStepperTop).observe(banner, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    // --- Active step on scroll ---
    // Progress-bar pages (taskpage / service-overview) render #JobStepperProgress;
    // step-line pages (static / category-details) render .job-step__line. Each
    // page has only one, so updating both here is harmless and behavior-preserving.
    if (stepperLinks.length && sections.length) {
      var updateActiveStep = function () {
        var scrollPosition = window.scrollY;
        var headerOffset = stepperWrapper.offsetHeight + 200;
        var progressBar = document.getElementById('JobStepperProgress');
        var totalSteps = document.querySelectorAll('#JobStepper .job-step').length;
        var lines = document.querySelectorAll('.job-step__line');

        sections.forEach(function (section, index) {
          var sectionTop = section.offsetTop - headerOffset;
          var sectionBottom = sectionTop + section.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            stepperLinks.forEach(function (link, linkIndex) {
              link.classList.toggle('is-active', linkIndex <= index);
            });
            if (progressBar && totalSteps > 0) {
              progressBar.style.width = ((index + 1) / totalSteps) * 100 + '%';
            }
            lines.forEach(function (line, lineIndex) {
              line.classList.toggle('is-completed', lineIndex < index);
            });
          }
        });
      };

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateActiveStep();
            ticking = false;
          });
          ticking = true;
        }
      });
      updateActiveStep();
    }

    // --- Mobile dropdown ---
    var toggleBtn = document.getElementById('JobStepperToggle');
    var dropdown = document.getElementById('JobStepperDropdown');
    var selectedText = document.getElementById('JobStepperSelected');
    var mobileItems = document.querySelectorAll('.job-stepper-mobile__item');

    if (toggleBtn && dropdown) {
      toggleBtn.addEventListener('click', function () {
        dropdown.classList.toggle('is-open');
      });
    }

    mobileItems.forEach(function (item) {
      item.addEventListener('click', function () {
        mobileItems.forEach(function (el) {
          el.classList.remove('is-active');
          var num = el.querySelector('.job-stepper-mobile__number');
          if (num) num.classList.remove('is-active');
        });

        this.classList.add('is-active');
        var currentNumber = this.querySelector('.job-stepper-mobile__number');
        if (currentNumber) currentNumber.classList.add('is-active');

        var content = this.querySelector('.job-stepper-mobile__content');
        if (content && selectedText) {
          selectedText.innerHTML = content.outerHTML;
          var selectedNumber = selectedText.querySelector('.job-stepper-mobile__number');
          if (selectedNumber) selectedNumber.classList.add('is-active');
        }

        if (dropdown) dropdown.classList.remove('is-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJobStepper);
  } else {
    initJobStepper();
  }
})();
